/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { Base, typeCast, Delegate_$type, fromEnum, runOn, markType, Point_$type, typeGetValue, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox, EventArgs, delegateCombine, fromEn, toNullable, Number_$type } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { ScaleTransform } from "igniteui-react-core";
import { NativeUI } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { stringReplace, stringIsNullOrEmpty } from "igniteui-react-core";
import { TransformGroup } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { SuffixShiftType_$type } from "./SuffixShiftType";
import { PrefixShiftType_$type } from "./PrefixShiftType";
import { LabelShiftType_$type } from "./LabelShiftType";
import { MouseButtonEventArgs } from "igniteui-react-core";
import { KeyEventArgs } from "igniteui-react-core";
import { InputShiftType_$type } from "./InputShiftType";
import { SuffixVisualModelExport } from "./SuffixVisualModelExport";
import { PrefixVisualModelExport } from "./PrefixVisualModelExport";
import { InputGroupDisplayType_$type } from "./InputGroupDisplayType";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { CornerRadius } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ThemeResolver } from "./ThemeResolver";
import { ObservableCollection$1 } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { InputGroupVisualModelExport } from "./InputGroupVisualModelExport";
import { AppearanceHelper } from "igniteui-react-core";
import { LabelVisualModelExport } from "./LabelVisualModelExport";
import { InputVisualModelExport } from "./InputVisualModelExport";
import { BrushUtil } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { MaskParsingService } from "./MaskParsingService";
import { InputChangeEventArgs } from "./InputChangeEventArgs";
import { MaskOptions } from "./MaskOptions";
/**
 * @hidden
 */
var InputGroupView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(InputGroupView, _super);
    function InputGroupView() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.l = null;
        _this.e = null;
        _this.i = new List$1(Delegate_$type, 0);
        _this.z = null;
        _this.f = true;
        _this.n = null;
        _this.o = null;
        _this.p = null;
        _this.t = null;
        _this.r = null;
        _this.q = null;
        _this.m = null;
        return _this;
    }
    InputGroupView.prototype.ak = function () {
    };
    InputGroupView.prototype.ac = function (a) {
        if (typeCast(XLabel.$, a) !== null) {
            a.bc = "flex-start";
        }
    };
    InputGroupView.prototype.ae = function (a) {
    };
    InputGroupView.prototype.ad = function () {
    };
    InputGroupView.prototype.g = function () {
        return true;
    };
    Object.defineProperty(InputGroupView.prototype, "w", {
        get: function () {
            return this.n;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "as", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "h", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    InputGroupView.prototype.ah = function (a) {
        var e_1, _a;
        var _this = this;
        if (a == null) {
            try {
                for (var _b = __values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.i.clear();
        }
        this.l = a;
        a.rootWrapper.setStyleProperty("position", "relative");
        a.rootWrapper.setStyleProperty("box-sizing", "border-box");
        a.rootWrapper.setStyleProperty("border-width", "0px");
        a.rootWrapper.setStyleProperty("border-style", "solid");
        var c = this.v;
        this.i.add(c.listen("focusin", runOn(this, this.aj)));
        this.i.add(c.listen("focusout", runOn(this, this.am)));
        var d = this.l.createElement("div");
        d.setStyleProperty("position", "absolute");
        d.setStyleProperty("width", "100%");
        d.setStyleProperty("height", "100%");
        d.setStyleProperty("border-style", "solid");
        d.setStyleProperty("box-sizing", "border-box");
        d.setStyleProperty("left", "0px");
        d.setStyleProperty("top", "0px");
        this.l.append(d);
        this.m = d;
        var e = this.l.createElement("div");
        e.addClass("ig-input-content");
        e.setStyleProperty("width", "100%");
        e.setStyleProperty("position", "relative");
        e.setStyleProperty("display", "flex");
        e.setStyleProperty("flex-direction", "row");
        e.setStyleProperty("flex-wrap", "no-wrap");
        e.setStyleProperty("flex-flow", "row nowrap");
        e.setStyleProperty("flex-grow", "1");
        e.setStyleProperty("align-items", "center");
        e.setStyleProperty("padding-top", "1.125rem");
        this.p = e;
        this.i.add(e.listen("click", runOn(this, this.aa)));
        this.l.append(e);
        this.l.getPortal(e, "ChildContent", function (f) {
            var comp_ = f.componentRef;
            _this.t = comp_;
            _this.p.setStyleProperty("flex-direction", "row");
        }, true);
        var f = this.l.createElement("div");
        f.setStyleProperty("position", "absolute");
        f.setStyleProperty("width", "100%");
        f.setStyleProperty("background-color", "rgba(0, 0, 0, 0.54)");
        f.setStyleProperty("height", "1px");
        f.setStyleProperty("pointer-events", "none");
        f.setStyleProperty("left", "0px");
        f.setStyleProperty("bottom", "1px");
        f.setStyleProperty("overflow", "visible");
        var g = this.l.createElement("span");
        g.setStyleProperty("width", "100%");
        g.setStyleProperty("height", "2px");
        g.setStyleProperty("display", "block");
        g.setStyleProperty("pointer-events", "none");
        NativeUI.ab(g, ((function () {
            var $ret = new ScaleTransform();
            $ret.l = 0.5;
            $ret.m = 1;
            return $ret;
        })()));
        g.setStyleProperty("opacity", "0");
        this.r = g;
        f.append(this.r);
        this.q = f;
        this.l.append(f);
        this.d.mf();
    };
    Object.defineProperty(InputGroupView.prototype, "s", {
        get: function () {
            return this.p;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "v", {
        get: function () {
            return this.l.rootWrapper;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "u", {
        get: function () {
            return this.m;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "x", {
        get: function () {
            return this.q;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputGroupView.prototype, "y", {
        get: function () {
            return this.r;
        },
        enumerable: false,
        configurable: true
    });
    InputGroupView.prototype.aq = function (a) {
        if (this.z != a) {
            this.z = a;
            if (this.o != null) {
                this.o.setAttribute("d", this.z);
            }
        }
    };
    InputGroupView.prototype.ap = function () {
        switch (this.d.g) {
            case 1:
                this.p.setStyleProperty("padding-top", "1.125rem");
                break;
            case 2:
                this.p.setStyleProperty("padding-top", ".94737rem");
                break;
            case 3:
                this.p.setStyleProperty("padding-top", ".81818rem");
                break;
        }
    };
    InputGroupView.prototype.aa = function (a) {
    };
    InputGroupView.prototype.al = function () {
        if (this.g()) {
        }
    };
    InputGroupView.prototype.j = function () {
        var a = this.l.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    InputGroupView.prototype.ag = function () {
        this.f = true;
    };
    InputGroupView.prototype.ai = function () {
        var e_2, _a;
        this.f = false;
        try {
            for (var _b = __values(fromEnum(this.i)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        this.i.clear();
    };
    InputGroupView.prototype.ar = function (a) {
        if (a != null) {
            this.l.rootWrapper.setStyleProperty("font", a.fontString);
        }
    };
    InputGroupView.prototype.k = function (a) {
        return a.view.i();
    };
    InputGroupView.prototype.af = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.l;
        }
    };
    InputGroupView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.u, 0, null, a);
    };
    InputGroupView.prototype.c = function (a) {
        return new AnimationKeyFrameEffect(0, this.x, 0, null, a);
    };
    InputGroupView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.r, 0, null, a);
    };
    InputGroupView.prototype.ao = function (a) {
    };
    InputGroupView.prototype.ab = function (a) {
        this.p.append(a);
    };
    InputGroupView.prototype.an = function (a) {
        this.p.removeChild(a);
    };
    InputGroupView.prototype.aj = function (a) {
        this.d.mb();
    };
    InputGroupView.prototype.am = function (a) {
        this.d.md();
    };
    InputGroupView.$t = markType(InputGroupView, 'InputGroupView');
    return InputGroupView;
}(Base));
export { InputGroupView };
/**
 * @hidden
 */
var SuffixView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SuffixView, _super);
    function SuffixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    SuffixView.prototype.o = function () {
    };
    SuffixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(SuffixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    SuffixView.prototype.m = function (a) {
        var e_3, _a;
        if (a == null) {
            try {
                for (var _b = __values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_3_1) {
                e_3 = { error: e_3_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_3)
                        throw e_3.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-suffix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.am();
    };
    SuffixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.k == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.ab(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    SuffixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    SuffixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    SuffixView.prototype.i = function (a) {
        this.a.aj();
    };
    SuffixView.prototype.j = function (a) {
        this.a.ak();
    };
    SuffixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    SuffixView.prototype.n = function () {
        var e_4, _a;
        this.c = false;
        try {
            for (var _b = __values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_4_1) {
            e_4 = { error: e_4_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_4)
                    throw e_4.error;
            }
        }
        this.e.clear();
    };
    SuffixView.prototype.k = function (a) {
        this.h.append(a);
    };
    SuffixView.$t = markType(SuffixView, 'SuffixView');
    return SuffixView;
}(Base));
export { SuffixView };
/**
 * @hidden
 */
var PrefixView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(PrefixView, _super);
    function PrefixView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.g = null;
        _this.b = null;
        _this.e = new List$1(Delegate_$type, 0);
        _this.c = true;
        _this.h = null;
        return _this;
    }
    PrefixView.prototype.o = function () {
    };
    PrefixView.prototype.d = function () {
        return true;
    };
    Object.defineProperty(PrefixView.prototype, "r", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    PrefixView.prototype.m = function (a) {
        var e_5, _a;
        if (a == null) {
            try {
                for (var _b = __values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_5_1) {
                e_5 = { error: e_5_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_5)
                        throw e_5.error;
                }
            }
            this.e.clear();
        }
        this.g = a;
        this.g.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.g.createElement("div");
        c.addClass("ig-prefix-content");
        this.g.append(c);
        c.setStyleProperty("cursor", "pointer");
        this.h = c;
        this.g.getPortal(c, "ChildContent", function (d) {
        }, true);
        this.a.am();
    };
    PrefixView.prototype.q = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.a.k == 2 ? (_this.f() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.ab(this.g.rootWrapper, a);
        this.g.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    PrefixView.prototype.f = function () {
        var a = this.g.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    PrefixView.prototype.p = function () {
        if (this.d()) {
        }
    };
    PrefixView.prototype.i = function (a) {
        this.a.aj();
    };
    PrefixView.prototype.j = function (a) {
        this.a.ak();
    };
    PrefixView.prototype.l = function () {
        this.c = true;
        this.e.add(this.g.rootWrapper.listen("mouseenter", runOn(this, this.i)));
        this.e.add(this.g.rootWrapper.listen("mouseleave", runOn(this, this.j)));
    };
    PrefixView.prototype.n = function () {
        var e_6, _a;
        this.c = false;
        try {
            for (var _b = __values(fromEnum(this.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_6_1) {
            e_6 = { error: e_6_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_6)
                    throw e_6.error;
            }
        }
        this.e.clear();
    };
    PrefixView.prototype.k = function (a) {
        this.h.append(a);
    };
    PrefixView.$t = markType(PrefixView, 'PrefixView');
    return PrefixView;
}(Base));
export { PrefixView };
/**
 * @hidden
 */
var LabelView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(LabelView, _super);
    function LabelView() {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.k = null;
        _this.d = null;
        _this.h = new List$1(Delegate_$type, 0);
        _this.o = null;
        _this.e = true;
        _this.l = null;
        _this.m = null;
        return _this;
    }
    LabelView.prototype.ab = function () {
    };
    LabelView.prototype.f = function () {
        return true;
    };
    Object.defineProperty(LabelView.prototype, "n", {
        get: function () {
            return this.l;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "aj", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelView.prototype, "g", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    LabelView.prototype.s = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.k;
        }
    };
    LabelView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.k.rootWrapper, 0, null, a);
    };
    LabelView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.k.rootWrapper, 0, null, a);
    };
    LabelView.prototype.w = function (a) {
        var e_7, _a;
        if (a == null) {
            try {
                for (var _b = __values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_7_1) {
                e_7 = { error: e_7_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_7)
                        throw e_7.error;
                }
            }
            this.h.clear();
        }
        this.k = a;
        this.k.rootWrapper.setStyleProperty("display", "inline-block");
        this.k.rootWrapper.setStyleProperty("position", "relative");
        var c = this.k.createElement("label");
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("white-space", "nowrap");
        c.setStyleProperty("text-overflow", "ellipsis");
        c.setStyleProperty("line-height", "1");
        c.setStyleProperty("overflow", "hidden");
        c.setStyleProperty("height", "1.125rem");
        c.setStyleProperty("backface-visibility", "hidden");
        NativeUI.o(this.k.rootWrapper, this.c.cz);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.l = c;
        this.k.append(this.l);
        this.c.ch();
    };
    LabelView.prototype.j = function () {
        return this.c.s == 0 ? (this.i() * 0.5) : 0;
    };
    LabelView.prototype.af = function () {
        var _this = this;
        this.c.bi = "block";
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.c.s == 0 ? (_this.i() * 0.5) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.ab(this.k.rootWrapper, a);
        this.l.setStyleProperty("height", "1.125rem");
        this.k.rootWrapper.setStyleProperty("position", "absolute");
        this.k.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    LabelView.prototype.ag = function () {
        switch (this.c.o) {
            case 1:
                this.k.rootWrapper.setStyleProperty("margin-top", "0px");
                break;
            case 2:
                this.k.rootWrapper.setStyleProperty("margin-top", "-.125rem");
                break;
            case 3:
                this.k.rootWrapper.setStyleProperty("margin-top", "-.25rem");
                break;
        }
    };
    LabelView.prototype.ae = function () {
        this.l.setText(this.c.text != null ? this.c.text : "");
    };
    LabelView.prototype.ah = function (a) {
        if (this.o != a) {
            this.o = a;
            if (this.m != null) {
                this.m.setAttribute("d", this.o);
            }
        }
    };
    LabelView.prototype.y = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("display", this.c.bi);
            this.l.setStyleProperty("display", this.c.bi);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onDisplayChanged) {
                ext_._onDisplayChanged();
            }
            ;
        }
    };
    LabelView.prototype.t = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("align-items", this.c.ba);
            this.l.setStyleProperty("align-items", this.c.ba);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onAlignItemsChanged) {
                ext_._onAlignItemsChanged();
            }
            ;
        }
    };
    LabelView.prototype.u = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("align-self", this.c.bc);
            this.l.setStyleProperty("align-self", this.c.bc);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onAlignSelfChanged) {
                ext_._onAlignSelfChanged();
            }
            ;
        }
    };
    LabelView.prototype.z = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("flex-direction", this.c.bl);
            this.l.setStyleProperty("flex-direction", this.c.bl);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onFlexDirectionChanged) {
                ext_._onFlexDirectionChanged();
            }
            ;
        }
    };
    LabelView.prototype.aa = function () {
        if (this.k != null) {
            this.k.rootWrapper.setStyleProperty("flex-grow", this.c.bn);
            this.l.setStyleProperty("flex-grow", this.c.bn);
            var ext_ = this.k.getExternal(this.c, null, null);
            if (ext_ && ext_._onFlexGrowChanged) {
                ext_._onFlexGrowChanged();
            }
            ;
        }
    };
    LabelView.prototype.p = function (a) {
    };
    LabelView.prototype.ac = function () {
        if (this.f()) {
        }
    };
    LabelView.prototype.i = function () {
        var a = this.k.rootWrapper.getStyleProperty("height");
        return parseFloat(stringReplace(a, "px", ""));
    };
    LabelView.prototype.q = function (a) {
        this.c.ce();
    };
    LabelView.prototype.r = function (a) {
        this.c.cf();
    };
    LabelView.prototype.v = function () {
        this.e = true;
        this.h.add(this.k.rootWrapper.listen("mouseenter", runOn(this, this.q)));
        this.h.add(this.k.rootWrapper.listen("mouseleave", runOn(this, this.r)));
    };
    LabelView.prototype.x = function () {
        var e_8, _a;
        this.e = false;
        try {
            for (var _b = __values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_8_1) {
            e_8 = { error: e_8_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_8)
                    throw e_8.error;
            }
        }
        this.h.clear();
    };
    LabelView.prototype.ai = function (a) {
        if (a != null) {
            this.l.setStyleProperty("font", a.fontString);
        }
    };
    LabelView.prototype.ad = function (a) {
        NativeUI.o(this.l, a);
    };
    LabelView.$t = markType(LabelView, 'LabelView');
    return LabelView;
}(Base));
export { LabelView };
/**
 * @hidden
 */
var InputView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(InputView, _super);
    function InputView() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.j = null;
        _this.c = null;
        _this.h = new List$1(Delegate_$type, 0);
        _this.e = false;
        _this.p = null;
        _this.d = true;
        _this.k = null;
        _this.l = null;
        return _this;
    }
    InputView.prototype.ao = function () {
    };
    InputView.prototype.f = function () {
        return true;
    };
    Object.defineProperty(InputView.prototype, "o", {
        get: function () {
            return this.k;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "a4", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputView.prototype, "g", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    InputView.prototype.al = function (a) {
        var e_9, _a;
        if (a == null) {
            try {
                for (var _b = __values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_9_1) {
                e_9 = { error: e_9_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_9)
                        throw e_9.error;
                }
            }
            this.h.clear();
        }
        this.j = a;
        this.j.rootWrapper.setStyleProperty("display", "inline-block");
        var c = this.j.createElement("input");
        c.setAttribute("type", this.b.b3);
        c.setStyleProperty("position", "relative");
        c.setStyleProperty("box-sizing", "border-box");
        c.setStyleProperty("display", "inline-block");
        c.setStyleProperty("border", "none");
        c.setStyleProperty("height", "2rem");
        c.setStyleProperty("line-height", "0");
        c.setStyleProperty("width", "100%");
        c.setStyleProperty("min-width", "0");
        c.setStyleProperty("overflow", "visible");
        c.setStyleProperty("background", "transparent");
        c.setStyleProperty("background-position-x", "initial");
        c.setStyleProperty("background-position-y", "initial");
        c.setStyleProperty("background-size", "initial");
        c.setStyleProperty("background-repeat-x", "initial");
        c.setStyleProperty("background-repeat-y", "initial");
        c.setStyleProperty("background-attachment", "initial");
        c.setStyleProperty("background-origin", "initial");
        c.setStyleProperty("background-color", "transparent");
        NativeUI.o(c, this.b.du);
        c.setStyleProperty("outline-style", "none");
        c.setStyleProperty("box-shadow", "none");
        c.setStyleProperty("border-top", "0.1875rem solid transparent");
        c.setStyleProperty("padding-bottom", "0.1875rem");
        c.setStyleProperty("font-family", "'Segoe UI', Verdana");
        c.setStyleProperty("font-size", "1rem");
        this.h.add(c.listen("change", runOn(this, this.v)));
        this.h.add(c.listen("input", runOn(this, this.w)));
        this.h.add(c.listen("focus", runOn(this, this.ab)));
        this.h.add(c.listen("blur", runOn(this, this.u)));
        this.h.add(c.listen("mouseenter", runOn(this, this.s)));
        this.h.add(c.listen("mouseleave", runOn(this, this.t)));
        this.h.add(c.listen("keydown", runOn(this, this.ac)));
        this.h.add(c.listen("keyup", runOn(this, this.ae)));
        this.h.add(c.listen("keypress", runOn(this, this.ad)));
        this.h.add(c.listen("paste", runOn(this, this.ah)));
        this.h.add(c.listen("dragenter", runOn(this, this.z)));
        this.h.add(c.listen("dragleave", runOn(this, this.aa)));
        this.h.add(c.listen("compositionstart", runOn(this, this.y)));
        this.h.add(c.listen("compositionend", runOn(this, this.x)));
        this.h.add(c.listen("mousedown", runOn(this, this.af)));
        this.h.add(c.listen("mouseup", runOn(this, this.ag)));
        this.k = c;
        this.j.append(this.k);
        this.b.dd();
    };
    InputView.prototype.av = function (a) {
        if (a) {
            this.k.setAttribute("readonly", a.toString());
        }
        else {
            this.k.getNativeElement().removeAttribute("readonly");
        }
    };
    InputView.prototype.au = function (a) {
        if (a) {
            this.k.setAttribute("disabled", "true");
        }
        else {
            this.k.getNativeElement().removeAttribute("disabled");
        }
    };
    InputView.prototype.y = function (a) {
        this.e = true;
        this.b.cv();
    };
    InputView.prototype.x = function (a) {
        this.e = false;
        this.b.cu();
    };
    InputView.prototype.as = function () {
        this.k.setAttribute("type", this.b.b3);
        if (this.b.b3 == "date") {
            this.k.setStyleProperty("line-height", "normal");
        }
        else {
            this.k.setStyleProperty("line-height", "0");
        }
    };
    InputView.prototype.aq = function () {
        this.k.setAttribute("placeholder", this.b.cb);
    };
    InputView.prototype.a0 = function () {
        switch (this.b.l) {
            case 1:
                this.k.setStyleProperty("height", "2rem");
                this.k.setStyleProperty("font-size", "1rem");
                break;
            case 2:
                this.k.setStyleProperty("height", "1.68421rem");
                this.k.setStyleProperty("font-size", "1rem");
                break;
            case 3:
                this.k.setStyleProperty("height", "1.45455rem");
                this.k.setStyleProperty("font-size", ".95455rem");
                break;
        }
    };
    InputView.prototype.az = function () {
        var _this = this;
        var a = new TransformGroup();
        a.j.add(((function () {
            var $ret = new TranslateTransform();
            $ret.k = _this.b.r == 2 ? (_this.i() * -0.25) : 0;
            return $ret;
        })()));
        a.j.add(((function () {
            var $ret = new ScaleTransform();
            $ret.l = 1;
            $ret.m = 1;
            return $ret;
        })()));
        NativeUI.ab(this.j.rootWrapper, a);
        this.j.rootWrapper.setStyleProperty("transform-origin", "0px 0px");
    };
    InputView.prototype.i = function () {
        var a = this.j.rootWrapper.getStyleProperty("height");
        var b = parseFloat(stringReplace(a, "px", ""));
        return b;
    };
    InputView.prototype.at = function (a) {
        this.k.setProperty("value", a);
    };
    InputView.prototype.u = function (a) {
        this.b.cr();
    };
    InputView.prototype.ab = function (a) {
        this.b.cz();
    };
    InputView.prototype.af = function (a) {
        var b = this.a3(a);
        this.b.c5(b);
        if (b.handled) {
            a.preventDefault();
        }
    };
    InputView.prototype.ag = function (a) {
        var b = this.a3(a);
        this.b.c8(b);
        if (b.handled) {
            a.preventDefault();
        }
    };
    InputView.prototype.a3 = function (a) {
        var b = new MouseButtonEventArgs();
        b.position = { $type: Point_$type, x: a.offsetX, y: a.offsetY };
        return b;
    };
    InputView.prototype.v = function (a) {
        this.b.cs();
    };
    InputView.prototype.w = function (a) {
        this.b.ct();
    };
    InputView.prototype.ac = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.c2(b);
    };
    InputView.prototype.ae = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.c4(b);
    };
    InputView.prototype.ad = function (a) {
        var b = new KeyEventArgs(0, a);
        this.b.c3(b);
    };
    InputView.prototype.ah = function (a) {
        this.b.c9();
    };
    InputView.prototype.z = function (a) {
        this.b.cx();
    };
    InputView.prototype.aa = function (a) {
        this.b.cy();
    };
    InputView.prototype.a1 = function (a) {
        if (this.p != a) {
            this.p = a;
            if (this.l != null) {
                this.l.setAttribute("d", this.p);
            }
        }
    };
    InputView.prototype.q = function () {
        return this.k.getProperty("value");
    };
    InputView.prototype.r = function (a) {
    };
    InputView.prototype.n = function () {
        var a = this.k.getProperty("selectionStart");
        return typeGetValue(a);
    };
    InputView.prototype.m = function () {
        var a = this.k.getProperty("selectionEnd");
        return typeGetValue(a);
    };
    InputView.prototype.ay = function (a) {
        this.k.setProperty("selectionStart", a);
    };
    InputView.prototype.aw = function (a) {
        this.k.setProperty("selectionEnd", a);
    };
    InputView.prototype.ap = function () {
        if (this.f()) {
        }
    };
    InputView.prototype.s = function (a) {
        this.b.c6();
    };
    InputView.prototype.t = function (a) {
        this.b.c7();
    };
    InputView.prototype.aj = function () {
        this.d = true;
        this.h.add(this.k.listen("change", runOn(this, this.v)));
        this.h.add(this.k.listen("input", runOn(this, this.w)));
        this.h.add(this.k.listen("focus", runOn(this, this.ab)));
        this.h.add(this.k.listen("blur", runOn(this, this.u)));
        this.h.add(this.k.listen("mouseenter", runOn(this, this.s)));
        this.h.add(this.k.listen("mouseleave", runOn(this, this.t)));
        this.h.add(this.k.listen("keydown", runOn(this, this.ac)));
        this.h.add(this.k.listen("paste", runOn(this, this.ah)));
        this.h.add(this.k.listen("dragenter", runOn(this, this.z)));
        this.h.add(this.k.listen("dragleave", runOn(this, this.aa)));
        this.h.add(this.k.listen("compositionstart", runOn(this, this.y)));
        this.h.add(this.k.listen("compositionend", runOn(this, this.x)));
        this.h.add(this.k.listen("mousedown", runOn(this, this.af)));
        this.h.add(this.k.listen("mouseup", runOn(this, this.ag)));
    };
    InputView.prototype.am = function () {
        var e_10, _a;
        this.d = false;
        try {
            for (var _b = __values(fromEnum(this.h)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a();
            }
        }
        catch (e_10_1) {
            e_10 = { error: e_10_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_10)
                    throw e_10.error;
            }
        }
        this.h.clear();
    };
    InputView.prototype.a2 = function (a) {
        if (a != null) {
            this.k.setStyleProperty("font", a.fontString);
        }
    };
    InputView.prototype.ak = function () {
        if (this.k != null) {
            var a = this.k.getNativeElement();
            a.blur();
        }
    };
    InputView.prototype.an = function (a) {
        if (this.k != null) {
            this.k.focus(a);
        }
    };
    InputView.prototype.ar = function () {
        if (this.k != null) {
            var nativeInput_ = this.k;
            nativeInput_.getNativeElement().select();
        }
    };
    InputView.prototype.ax = function (a, b) {
        if (this.k != null) {
            var c = this.k.getNativeElement();
            c.setSelectionRange(a, b);
        }
    };
    InputView.prototype.ai = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.j;
        }
    };
    InputView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.j.rootWrapper, 0, null, a);
    };
    InputView.$t = markType(InputView, 'InputView');
    return InputView;
}(Base));
export { InputView };
/**
 * @hidden
 */
var XInputGroupItem = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XInputGroupItem, _super);
    function XInputGroupItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = null;
        _this.a = null;
        _this.propertyChanged = null;
        return _this;
    }
    Object.defineProperty(XInputGroupItem.prototype, "e", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.g("Name", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroupItem.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.g("InputGroup", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInputGroupItem.prototype.g = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.h(a, b, c);
    };
    XInputGroupItem.prototype.h = function (a, b, c) {
    };
    XInputGroupItem.$t = markType(XInputGroupItem, 'XInputGroupItem', Base.$, [INotifyPropertyChanged_$type]);
    return XInputGroupItem;
}(Base));
export { XInputGroupItem };
/**
 * @hidden
 */
var XSuffix = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XSuffix, _super);
    function XSuffix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.j = 0;
        _this.v = "ig-suffix-" + XSuffix.s++;
        _this.u = null;
        _this.n = false;
        _this.m = false;
        _this.o = false;
        var a = new SuffixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(XSuffix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: false,
        configurable: true
    });
    XSuffix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(XSuffix.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ShiftType", enumGetBox(SuffixShiftType_$type, b), enumGetBox(SuffixShiftType_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    XSuffix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.ai();
                break;
            case "ShiftType":
                this.al();
                break;
        }
    };
    XSuffix.prototype.al = function () {
        this.view.q();
    };
    XSuffix.prototype.ai = function () {
        this.view.q();
    };
    XSuffix.prototype.ap = function () {
    };
    XSuffix.prototype.ao = function () {
    };
    XSuffix.prototype.aj = function () {
        this.q = true;
    };
    XSuffix.prototype.ak = function () {
        this.q = false;
    };
    Object.defineProperty(XSuffix.prototype, "z", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("Id", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XSuffix.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XSuffix.prototype, "q", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XSuffix.prototype, "disabled", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XSuffix.prototype.am = function () {
    };
    XSuffix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    XSuffix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    XSuffix.prototype.r = function () {
        return this.view.d();
    };
    XSuffix.prototype.t = function () {
        return this.i();
    };
    XSuffix.prototype.y = function () {
        var a = this.i();
        return a.e();
    };
    XSuffix.prototype.i = function () {
        var a = new SuffixVisualModelExport();
        a.a = this.k;
        a.c = this.q;
        a.b = this.disabled;
        a.d = this.e;
        return a;
    };
    XSuffix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    XSuffix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    XSuffix.$t = markType(XSuffix, 'XSuffix', XInputGroupItem.$);
    XSuffix.s = 0;
    return XSuffix;
}(XInputGroupItem));
export { XSuffix };
/**
 * @hidden
 */
var XPrefix = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XPrefix, _super);
    function XPrefix() {
        var _this = _super.call(this) || this;
        _this._view = null;
        _this.j = 0;
        _this.v = "ig-prefix-" + XPrefix.s++;
        _this.u = null;
        _this.n = false;
        _this.m = false;
        _this.o = false;
        var a = new PrefixView();
        a.a = _this;
        _this.view = a;
        _this.view.o();
        return _this;
    }
    Object.defineProperty(XPrefix.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: false,
        configurable: true
    });
    XPrefix.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(XPrefix.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ShiftType", enumGetBox(PrefixShiftType_$type, b), enumGetBox(PrefixShiftType_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    XPrefix.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "InputGroup":
                this.ai();
                break;
            case "ShiftType":
                this.al();
                break;
        }
    };
    XPrefix.prototype.al = function () {
        this.view.q();
    };
    XPrefix.prototype.ai = function () {
        this.view.q();
    };
    XPrefix.prototype.ap = function () {
    };
    XPrefix.prototype.ao = function () {
    };
    XPrefix.prototype.aj = function () {
        this.q = true;
    };
    XPrefix.prototype.ak = function () {
        this.q = false;
    };
    Object.defineProperty(XPrefix.prototype, "z", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("Id", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XPrefix.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XPrefix.prototype, "q", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XPrefix.prototype, "disabled", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XPrefix.prototype.am = function () {
    };
    XPrefix.prototype.onDetachedFromUI = function () {
        this.view.n();
    };
    XPrefix.prototype.onAttachedToUI = function () {
        this.view.l();
    };
    XPrefix.prototype.r = function () {
        return this.view.d();
    };
    XPrefix.prototype.t = function () {
        return this.i();
    };
    XPrefix.prototype.y = function () {
        var a = this.i();
        return a.e();
    };
    XPrefix.prototype.i = function () {
        var a = new PrefixVisualModelExport();
        a.a = this.k;
        a.c = this.q;
        a.b = this.disabled;
        a.d = this.e;
        return a;
    };
    XPrefix.prototype.appendContentChild = function (a) {
        this.view.k(a);
    };
    XPrefix.prototype.provideContainer = function (a) {
        this.view.m(a);
    };
    XPrefix.$t = markType(XPrefix, 'XPrefix', XInputGroupItem.$);
    XPrefix.s = 0;
    return XPrefix;
}(XInputGroupItem));
export { XPrefix };
/**
 * @hidden
 */
var XInputGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XInputGroup, _super);
    function XInputGroup() {
        var _this = _super.call(this) || this;
        _this.j = 0;
        _this.f = 1;
        _this.e = 1;
        _this.ad = false;
        _this.b = 0;
        _this._view = null;
        _this.q = null;
        _this.o = null;
        _this.lostFocus = null;
        _this.gotFocus = null;
        _this.df = ThemeResolver.b(XInputGroup.c, XInputGroup.fu, XInputGroup.d1);
        _this.e5 = ThemeResolver.b(XInputGroup.c, XInputGroup.f5, XInputGroup.ec);
        _this.m7 = ThemeResolver.d(XInputGroup.c, XInputGroup.ng, XInputGroup.na);
        _this.tn = ThemeResolver.f(XInputGroup.c, XInputGroup.tw, XInputGroup.tq);
        _this.pg = ThemeResolver.e(XInputGroup.c, XInputGroup.re, XInputGroup.py);
        _this.q1 = ThemeResolver.e(XInputGroup.c, XInputGroup.rv, XInputGroup.qf);
        _this.q2 = ThemeResolver.e(XInputGroup.c, XInputGroup.rw, XInputGroup.qg);
        _this.hb = ThemeResolver.b(XInputGroup.c, XInputGroup.gx, XInputGroup.e4);
        _this.ha = ThemeResolver.b(XInputGroup.c, XInputGroup.gw, XInputGroup.e3);
        _this.e9 = ThemeResolver.b(XInputGroup.c, XInputGroup.f9, XInputGroup.eg);
        _this.sp = ThemeResolver.e(XInputGroup.c, XInputGroup.sf, XInputGroup.qz);
        _this.sq = ThemeResolver.e(XInputGroup.c, XInputGroup.sg, XInputGroup.q0);
        _this.q4 = ThemeResolver.e(XInputGroup.c, XInputGroup.ry, XInputGroup.qi);
        _this.q3 = ThemeResolver.e(XInputGroup.c, XInputGroup.rx, XInputGroup.qh);
        _this.g8 = ThemeResolver.b(XInputGroup.c, XInputGroup.gu, XInputGroup.e1);
        _this.e8 = ThemeResolver.b(XInputGroup.c, XInputGroup.f8, XInputGroup.ef);
        _this.e6 = ThemeResolver.b(XInputGroup.c, XInputGroup.f6, XInputGroup.ed);
        _this.e7 = ThemeResolver.b(XInputGroup.c, XInputGroup.f7, XInputGroup.ee);
        _this.g9 = ThemeResolver.b(XInputGroup.c, XInputGroup.gv, XInputGroup.e2);
        _this.pf = ThemeResolver.e(XInputGroup.c, XInputGroup.rd, XInputGroup.px);
        _this.fa = ThemeResolver.b(XInputGroup.c, XInputGroup.ga, XInputGroup.eh);
        _this.fb = ThemeResolver.b(XInputGroup.c, XInputGroup.gb, XInputGroup.ei);
        _this.nd = ThemeResolver.d(XInputGroup.c, XInputGroup.nh, XInputGroup.nb);
        _this.tt = ThemeResolver.f(XInputGroup.c, XInputGroup.tx, XInputGroup.tr);
        _this.q6 = ThemeResolver.e(XInputGroup.c, XInputGroup.r0, XInputGroup.qk);
        _this.q7 = ThemeResolver.e(XInputGroup.c, XInputGroup.r1, XInputGroup.ql);
        _this.q8 = ThemeResolver.e(XInputGroup.c, XInputGroup.r2, XInputGroup.qm);
        _this.fj = ThemeResolver.b(XInputGroup.c, XInputGroup.gj, XInputGroup.eq);
        _this.fi = ThemeResolver.b(XInputGroup.c, XInputGroup.gi, XInputGroup.ep);
        _this.ff = ThemeResolver.b(XInputGroup.c, XInputGroup.gf, XInputGroup.em);
        _this.rb = ThemeResolver.e(XInputGroup.c, XInputGroup.r5, XInputGroup.qp);
        _this.rc = ThemeResolver.e(XInputGroup.c, XInputGroup.r6, XInputGroup.qq);
        _this.ra = ThemeResolver.e(XInputGroup.c, XInputGroup.r4, XInputGroup.qo);
        _this.q9 = ThemeResolver.e(XInputGroup.c, XInputGroup.r3, XInputGroup.qn);
        _this.fg = ThemeResolver.b(XInputGroup.c, XInputGroup.gg, XInputGroup.en);
        _this.fe = ThemeResolver.b(XInputGroup.c, XInputGroup.ge, XInputGroup.el);
        _this.fc = ThemeResolver.b(XInputGroup.c, XInputGroup.gc, XInputGroup.ej);
        _this.fd = ThemeResolver.b(XInputGroup.c, XInputGroup.gd, XInputGroup.ek);
        _this.fh = ThemeResolver.b(XInputGroup.c, XInputGroup.gh, XInputGroup.eo);
        _this.q5 = ThemeResolver.e(XInputGroup.c, XInputGroup.rz, XInputGroup.qj);
        _this.dg = ThemeResolver.b(XInputGroup.c, XInputGroup.fv, XInputGroup.d2);
        _this.dh = ThemeResolver.b(XInputGroup.c, XInputGroup.fw, XInputGroup.d3);
        _this.m6 = ThemeResolver.d(XInputGroup.c, XInputGroup.nf, XInputGroup.m9);
        _this.tm = ThemeResolver.f(XInputGroup.c, XInputGroup.tv, XInputGroup.tp);
        _this.pq = ThemeResolver.e(XInputGroup.c, XInputGroup.ro, XInputGroup.p8);
        _this.pr = ThemeResolver.e(XInputGroup.c, XInputGroup.rp, XInputGroup.p9);
        _this.ps = ThemeResolver.e(XInputGroup.c, XInputGroup.rq, XInputGroup.qa);
        _this.dq = ThemeResolver.b(XInputGroup.c, XInputGroup.f4, XInputGroup.eb);
        _this.dp = ThemeResolver.b(XInputGroup.c, XInputGroup.f3, XInputGroup.ea);
        _this.dl = ThemeResolver.b(XInputGroup.c, XInputGroup.f0, XInputGroup.d7);
        _this.pv = ThemeResolver.e(XInputGroup.c, XInputGroup.rt, XInputGroup.qd);
        _this.pw = ThemeResolver.e(XInputGroup.c, XInputGroup.ru, XInputGroup.qe);
        _this.pu = ThemeResolver.e(XInputGroup.c, XInputGroup.rs, XInputGroup.qc);
        _this.pt = ThemeResolver.e(XInputGroup.c, XInputGroup.rr, XInputGroup.qb);
        _this.dm = ThemeResolver.b(XInputGroup.c, XInputGroup.f1, XInputGroup.d8);
        _this.dk = ThemeResolver.b(XInputGroup.c, XInputGroup.fz, XInputGroup.d6);
        _this.di = ThemeResolver.b(XInputGroup.c, XInputGroup.fx, XInputGroup.d4);
        _this.dj = ThemeResolver.b(XInputGroup.c, XInputGroup.fy, XInputGroup.d5);
        _this.dn = ThemeResolver.b(XInputGroup.c, XInputGroup.f2, XInputGroup.d9);
        _this.pp = ThemeResolver.e(XInputGroup.c, XInputGroup.rn, XInputGroup.p7);
        _this.c5 = ThemeResolver.b(XInputGroup.c, XInputGroup.fk, XInputGroup.dr);
        _this.c6 = ThemeResolver.b(XInputGroup.c, XInputGroup.fl, XInputGroup.ds);
        _this.m5 = ThemeResolver.d(XInputGroup.c, XInputGroup.ne, XInputGroup.m8);
        _this.tl = ThemeResolver.f(XInputGroup.c, XInputGroup.tu, XInputGroup.to);
        _this.pi = ThemeResolver.e(XInputGroup.c, XInputGroup.rg, XInputGroup.p0);
        _this.pj = ThemeResolver.e(XInputGroup.c, XInputGroup.rh, XInputGroup.p1);
        _this.pk = ThemeResolver.e(XInputGroup.c, XInputGroup.ri, XInputGroup.p2);
        _this.de = ThemeResolver.b(XInputGroup.c, XInputGroup.ft, XInputGroup.d0);
        _this.dd = ThemeResolver.b(XInputGroup.c, XInputGroup.fs, XInputGroup.dz);
        _this.da = ThemeResolver.b(XInputGroup.c, XInputGroup.fp, XInputGroup.dw);
        _this.pn = ThemeResolver.e(XInputGroup.c, XInputGroup.rl, XInputGroup.p5);
        _this.po = ThemeResolver.e(XInputGroup.c, XInputGroup.rm, XInputGroup.p6);
        _this.pm = ThemeResolver.e(XInputGroup.c, XInputGroup.rk, XInputGroup.p4);
        _this.pl = ThemeResolver.e(XInputGroup.c, XInputGroup.rj, XInputGroup.p3);
        _this.db = ThemeResolver.b(XInputGroup.c, XInputGroup.fq, XInputGroup.dx);
        _this.c9 = ThemeResolver.b(XInputGroup.c, XInputGroup.fo, XInputGroup.dv);
        _this.c7 = ThemeResolver.b(XInputGroup.c, XInputGroup.fm, XInputGroup.dt);
        _this.c8 = ThemeResolver.b(XInputGroup.c, XInputGroup.fn, XInputGroup.du);
        _this.dc = ThemeResolver.b(XInputGroup.c, XInputGroup.fr, XInputGroup.dy);
        _this.ph = ThemeResolver.e(XInputGroup.c, XInputGroup.rf, XInputGroup.pz);
        _this.gy = ThemeResolver.b(XInputGroup.c, XInputGroup.gk, XInputGroup.er);
        _this.gz = ThemeResolver.b(XInputGroup.c, XInputGroup.gl, XInputGroup.es);
        _this.nj = ThemeResolver.d(XInputGroup.c, XInputGroup.ni, XInputGroup.nc);
        _this.tz = ThemeResolver.f(XInputGroup.c, XInputGroup.ty, XInputGroup.ts);
        _this.si = ThemeResolver.e(XInputGroup.c, XInputGroup.r8, XInputGroup.qs);
        _this.sj = ThemeResolver.e(XInputGroup.c, XInputGroup.r9, XInputGroup.qt);
        _this.sk = ThemeResolver.e(XInputGroup.c, XInputGroup.sa, XInputGroup.qu);
        _this.g7 = ThemeResolver.b(XInputGroup.c, XInputGroup.gt, XInputGroup.e0);
        _this.g6 = ThemeResolver.b(XInputGroup.c, XInputGroup.gs, XInputGroup.ez);
        _this.g3 = ThemeResolver.b(XInputGroup.c, XInputGroup.gp, XInputGroup.ew);
        _this.sn = ThemeResolver.e(XInputGroup.c, XInputGroup.sd, XInputGroup.qx);
        _this.so = ThemeResolver.e(XInputGroup.c, XInputGroup.se, XInputGroup.qy);
        _this.sm = ThemeResolver.e(XInputGroup.c, XInputGroup.sc, XInputGroup.qw);
        _this.sl = ThemeResolver.e(XInputGroup.c, XInputGroup.sb, XInputGroup.qv);
        _this.g4 = ThemeResolver.b(XInputGroup.c, XInputGroup.gq, XInputGroup.ex);
        _this.g2 = ThemeResolver.b(XInputGroup.c, XInputGroup.go, XInputGroup.ev);
        _this.g0 = ThemeResolver.b(XInputGroup.c, XInputGroup.gm, XInputGroup.et);
        _this.g1 = ThemeResolver.b(XInputGroup.c, XInputGroup.gn, XInputGroup.eu);
        _this.g5 = ThemeResolver.b(XInputGroup.c, XInputGroup.gr, XInputGroup.ey);
        _this.sh = ThemeResolver.e(XInputGroup.c, XInputGroup.r7, XInputGroup.qr);
        _this.nn = ThemeResolver.e(XInputGroup.c, XInputGroup.re, XInputGroup.py);
        _this.no = ThemeResolver.e(XInputGroup.c, XInputGroup.rv, XInputGroup.qf);
        _this.am = ThemeResolver.b(XInputGroup.c, XInputGroup.fu, XInputGroup.d1);
        _this.an = ThemeResolver.b(XInputGroup.c, XInputGroup.f5, XInputGroup.ec);
        _this.mu = ThemeResolver.d(XInputGroup.c, XInputGroup.ng, XInputGroup.na);
        _this.ta = ThemeResolver.f(XInputGroup.c, XInputGroup.tw, XInputGroup.tq);
        _this.av = ThemeResolver.b(XInputGroup.c, XInputGroup.gx, XInputGroup.e4);
        _this.au = ThemeResolver.b(XInputGroup.c, XInputGroup.gw, XInputGroup.e3);
        _this.ar = ThemeResolver.b(XInputGroup.c, XInputGroup.f9, XInputGroup.eg);
        _this.nr = ThemeResolver.e(XInputGroup.c, XInputGroup.sf, XInputGroup.qz);
        _this.ns = ThemeResolver.e(XInputGroup.c, XInputGroup.sg, XInputGroup.q0);
        _this.nq = ThemeResolver.e(XInputGroup.c, XInputGroup.ry, XInputGroup.qi);
        _this.np = ThemeResolver.e(XInputGroup.c, XInputGroup.rx, XInputGroup.qh);
        _this.as = ThemeResolver.b(XInputGroup.c, XInputGroup.gu, XInputGroup.e1);
        _this.aq = ThemeResolver.b(XInputGroup.c, XInputGroup.f8, XInputGroup.ef);
        _this.ao = ThemeResolver.b(XInputGroup.c, XInputGroup.f6, XInputGroup.ed);
        _this.ap = ThemeResolver.b(XInputGroup.c, XInputGroup.f7, XInputGroup.ee);
        _this.at = ThemeResolver.b(XInputGroup.c, XInputGroup.gv, XInputGroup.e2);
        _this.nm = ThemeResolver.e(XInputGroup.c, XInputGroup.rd, XInputGroup.px);
        _this.a6 = NaN;
        _this.bh = NaN;
        _this.nu = null;
        _this.mx = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.td = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b9 = NaN;
        _this.b8 = NaN;
        _this.bl = NaN;
        _this.oq = null;
        _this.or = null;
        _this.ob = null;
        _this.oa = null;
        _this.b6 = NaN;
        _this.bk = NaN;
        _this.bi = NaN;
        _this.bj = NaN;
        _this.b7 = NaN;
        _this.nt = null;
        _this.bm = NaN;
        _this.bn = NaN;
        _this.oe = null;
        _this.od = null;
        _this.my = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.te = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.bv = NaN;
        _this.bu = NaN;
        _this.br = NaN;
        _this.oh = null;
        _this.oi = null;
        _this.og = null;
        _this.of = null;
        _this.bs = NaN;
        _this.bq = NaN;
        _this.bo = NaN;
        _this.bp = NaN;
        _this.bt = NaN;
        _this.oc = null;
        _this.a7 = NaN;
        _this.a8 = NaN;
        _this.n4 = null;
        _this.n3 = null;
        _this.mw = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.tc = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.bg = NaN;
        _this.bf = NaN;
        _this.bc = NaN;
        _this.n7 = null;
        _this.n8 = null;
        _this.n6 = null;
        _this.n5 = null;
        _this.bd = NaN;
        _this.bb = NaN;
        _this.a9 = NaN;
        _this.ba = NaN;
        _this.be = NaN;
        _this.n2 = null;
        _this.aw = NaN;
        _this.ax = NaN;
        _this.nx = null;
        _this.nw = null;
        _this.mv = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.tb = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.a5 = NaN;
        _this.a4 = NaN;
        _this.a1 = NaN;
        _this.n0 = null;
        _this.n1 = null;
        _this.nz = null;
        _this.ny = null;
        _this.a2 = NaN;
        _this.a0 = NaN;
        _this.ay = NaN;
        _this.az = NaN;
        _this.a3 = NaN;
        _this.nv = null;
        _this.bw = NaN;
        _this.bx = NaN;
        _this.ol = null;
        _this.ok = null;
        _this.mz = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.tf = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.b5 = NaN;
        _this.b4 = NaN;
        _this.b1 = NaN;
        _this.oo = null;
        _this.op = null;
        _this.on = null;
        _this.om = null;
        _this.b2 = NaN;
        _this.b0 = NaN;
        _this.by = NaN;
        _this.bz = NaN;
        _this.b3 = NaN;
        _this.oj = null;
        _this.x = false;
        _this.t = false;
        _this.z = false;
        _this.v = false;
        _this.y = false;
        _this.u = false;
        _this.r = false;
        _this.n9 = null;
        _this.ib = "ig-inputgroup-" + XInputGroup.h8++;
        _this.w = false;
        _this.propertyChanged = null;
        _this.l = new XInputGroupInputCollection();
        _this.p = null;
        _this.ab = false;
        _this.s = false;
        _this.aa = false;
        _this.h9 = toNullable(Number_$type, null);
        var a = new InputGroupView();
        a.d = _this;
        _this.view = a;
        _this.view.ak();
        var b = _this.l;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.lx));
        var c = _this.l;
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.ly));
        return _this;
    }
    XInputGroup.prototype.ly = function (a, b) {
        this.mn();
        this.view.ad();
    };
    XInputGroup.prototype.appendContentChild = function (a) {
        this.view.ab(a);
    };
    XInputGroup.prototype.mj = function (a) {
        this.view.an(a);
    };
    Object.defineProperty(XInputGroup.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.me("DisplayType", enumGetBox(InputGroupDisplayType_$type, b), enumGetBox(InputGroupDisplayType_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (b != this.f) {
                this.me("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "g", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (b != this.e) {
                this.me("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.l4 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(XLabel.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    XInputGroup.prototype.l5 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(XPrefix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    XInputGroup.prototype.l3 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(XInput.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    XInputGroup.prototype.l6 = function (a) {
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(XSuffix.$, this.inputs._inner[b]) !== null) {
                a(this.inputs._inner[b]);
            }
        }
    };
    XInputGroup.prototype.lx = function (a, b) {
        var e_11, _a, e_12, _b;
        if (b.oldItems != null) {
            try {
                for (var _c = __values(fromEn(b.oldItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    var d = c;
                    if (d != null) {
                        d.b = null;
                    }
                    this.view.ae(d);
                }
            }
            catch (e_11_1) {
                e_11 = { error: e_11_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_11)
                        throw e_11.error;
                }
            }
        }
        if (b.newItems != null) {
            try {
                for (var _e = __values(fromEn(b.newItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var e = _f.value;
                    var f = e;
                    if (f != null) {
                        f.b = this;
                    }
                    this.view.ac(f);
                }
            }
            catch (e_12_1) {
                e_12 = { error: e_12_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_12)
                        throw e_12.error;
                }
            }
        }
        this.ml();
        this.ad = true;
        try {
            this.mt();
        }
        finally {
            this.ad = false;
        }
        this.mq();
        this.mp();
        this.mr();
        this.ms();
        this.mn();
    };
    Object.defineProperty(XInputGroup.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.me("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.destroy = function () {
        this.provideContainer(null);
    };
    XInputGroup.prototype.me = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.mh(a, b, c);
    };
    XInputGroup.prototype.mh = function (a, b, c) {
        var _this = this;
        switch (a) {
            case "BaseTheme":
                this.mm(this.d);
                this.mo();
                this.l4(function (d) { return d.l = _this.d == 0 ? 2 : _this.d; });
                break;
            case "ActualBorderColor":
            case "ActualBackgroundColor":
            case "ActualBorderWidth":
            case "ActualFocusBorderColor":
            case "ActualFocusBorderWidth":
            case "ActualCornerRadius":
            case "ActualContentPadding":
            case "ActualUnderlineOpacity":
            case "ActualUnderlineRippleOpacity":
            case "ActualUnderlineRippleWidth":
            case "ActualUnderlineRippleColor":
            case "ActualUnderlineColor":
            case "ActualHoverUnderlineColor":
            case "ActualUnderlineWidth":
            case "ActualHoverUnderlineWidth":
            case "ActualHoverUnderlineOpacity":
            case "ActualFocusUnderlineColor":
            case "ActualFocusUnderlineOpacity":
            case "ActualFocusUnderlineRippleOpacity":
            case "IsHovered":
                this.aa = true;
                this.ab = true;
                this.s = true;
                this.mn();
                break;
            case "BorderColor":
            case "BackgroundColor":
            case "BorderWidth":
            case "FocusBorderColor":
            case "FocusBorderWidth":
            case "CornerRadius":
            case "ContentPadding":
            case "UnderlineOpacity":
            case "UnderlineRippleOpacity":
            case "UnderlineRippleWidth":
            case "UnderlineRippleColor":
            case "UnderlineColor":
            case "HoverUnderlineColor":
            case "UnderlineWidth":
            case "HoverUnderlineWidth":
            case "HoverUnderlineOpacity":
            case "FocusUnderlineColor":
            case "FocusUnderlineOpacity":
            case "FocusUnderlineRippleOpacity":
            case "LineTypeBorderColor":
            case "LineTypeBackgroundColor":
            case "LineTypeBorderWidth":
            case "LineTypeFocusBorderColor":
            case "LineTypeFocusBorderWidth":
            case "LineTypeCornerRadius":
            case "LineTypeContentPadding":
            case "LineTypeUnderlineOpacity":
            case "LineTypeUnderlineRippleOpacity":
            case "LineTypeUnderlineRippleWidth":
            case "LineTypeUnderlineRippleColor":
            case "LineTypeUnderlineColor":
            case "LineTypeHoverUnderlineColor":
            case "LineTypeUnderlineWidth":
            case "LineTypeHoverUnderlineWidth":
            case "LineTypeHoverUnderlineOpacity":
            case "LineTypeFocusUnderlineColor":
            case "LineTypeFocusUnderlineOpacity":
            case "LineTypeFocusUnderlineRippleOpacity":
            case "BoxTypeBorderColor":
            case "BoxTypeBackgroundColor":
            case "BoxTypeBorderWidth":
            case "BoxTypeFocusBorderColor":
            case "BoxTypeFocusBorderWidth":
            case "BoxTypeCornerRadius":
            case "BoxTypeContentPadding":
            case "BoxTypeUnderlineOpacity":
            case "BoxTypeUnderlineRippleOpacity":
            case "BoxTypeUnderlineRippleWidth":
            case "BoxTypeUnderlineRippleColor":
            case "BoxTypeUnderlineColor":
            case "BoxTypeHoverUnderlineColor":
            case "BoxTypeUnderlineWidth":
            case "BoxTypeHoverUnderlineWidth":
            case "BoxTypeHoverUnderlineOpacity":
            case "BoxTypeFocusUnderlineColor":
            case "BoxTypeFocusUnderlineOpacity":
            case "BoxTypeFocusUnderlineRippleOpacity":
            case "BorderTypeBorderColor":
            case "BorderTypeBackgroundColor":
            case "BorderTypeBorderWidth":
            case "BorderTypeFocusBorderColor":
            case "BorderTypeFocusBorderWidth":
            case "BorderTypeCornerRadius":
            case "BorderTypeContentPadding":
            case "BorderTypeUnderlineOpacity":
            case "BorderTypeUnderlineRippleOpacity":
            case "BorderTypeUnderlineRippleWidth":
            case "BorderTypeUnderlineRippleColor":
            case "BorderTypeUnderlineColor":
            case "BorderTypeHoverUnderlineColor":
            case "BorderTypeUnderlineWidth":
            case "BorderTypeHoverUnderlineWidth":
            case "BorderTypeHoverUnderlineOpacity":
            case "BorderTypeFocusUnderlineColor":
            case "BorderTypeFocusUnderlineOpacity":
            case "BorderTypeFocusUnderlineRippleOpacity":
            case "DisplayType":
                this.mo();
                break;
            case "ActualDensity":
                this.view.ap();
                this.mo();
                break;
            case "Density":
                this.g = this.h == 0 ? 1 : this.h;
                break;
            case "IsFocused":
                this.mc();
                this.mn();
                break;
            case "IsExpanded":
                this.t = true;
                this.ac = this.ah;
                break;
            case "ActualIsExpanded":
                this.l7();
                break;
        }
    };
    XInputGroup.m3 = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    XInputGroup.tj = function (a, b) {
        return new Thickness(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.e) ? a.e : b.e, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b);
    };
    XInputGroup.prototype.mq = function () {
        var _this = this;
        this.l4(function (a) {
            a.p = _this.g;
            a.l = _this.d == 0 ? 2 : _this.d;
            switch (_this.k) {
                case 0:
                    a.s = 0;
                    break;
                case 1:
                    a.s = 1;
                    break;
                case 2:
                case 3:
                    a.s = 2;
                    break;
            }
            a.ck(_this.ac, false);
        });
    };
    XInputGroup.prototype.mr = function () {
        var _this = this;
        this.l5(function (a) {
            switch (_this.k) {
                case 0:
                    a.k = 0;
                    break;
                case 1:
                    a.k = 1;
                    break;
                case 2:
                case 3:
                    a.k = 2;
                    break;
            }
        });
    };
    XInputGroup.prototype.mp = function () {
        var _this = this;
        this.l3(function (a) {
            a.m = _this.g;
            switch (_this.k) {
                case 0:
                    a.r = 0;
                    break;
                case 1:
                    a.r = 1;
                    break;
                case 2:
                case 3:
                    a.r = 2;
                    break;
            }
            a.dh(_this.al, false);
        });
    };
    XInputGroup.prototype.ms = function () {
        var _this = this;
        this.l6(function (a) {
            switch (_this.k) {
                case 0:
                    a.k = 0;
                    break;
                case 1:
                    a.k = 1;
                    break;
                case 2:
                case 3:
                    a.k = 2;
                    break;
            }
        });
    };
    XInputGroup.prototype.mo = function () {
        this.mq();
        this.mp();
        this.mr();
        this.ms();
        switch (this.k) {
            case 0:
                this.ot = this.o0 != null ? this.o0 : this.sv != null ? this.sv : this.q6;
                this.os = this.oz != null ? this.oz : this.su != null ? this.su : this.q5;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.hh) ? this.hh : this.fa;
                this.ou = this.sr != null ? this.sr : this.sw != null ? this.sw : this.q7;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hi) ? this.hi : this.fb;
                this.m0 = XInputGroup.m3(this.m4, XInputGroup.m3(this.nk, this.nd));
                this.tg = XInputGroup.tj(this.tk, XInputGroup.tj(this.t0, this.tt));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.hn) ? this.hn : this.fg;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.ho) ? this.ho : this.fh;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.hp) ? this.hp : this.fi;
                this.oy = this.s9 != null ? this.s9 : this.s0 != null ? this.s0 : this.rc;
                this.ox = this.s8 != null ? this.s8 : this.sz != null ? this.sz : this.rb;
                this.ow = this.st != null ? this.st : this.sy != null ? this.sy : this.ra;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.hq) ? this.hq : this.fj;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.hm) ? this.hm : this.ff;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.hl) ? this.hl : this.fe;
                this.ov = this.ss != null ? this.ss : this.sx != null ? this.sx : this.q9;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.hj) ? this.hj : this.fc;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.hk) ? this.hk : this.fd;
                break;
            case 1:
                this.ot = this.o0 != null ? this.o0 : this.o9 != null ? this.o9 : this.pq;
                this.os = this.oz != null ? this.oz : this.o8 != null ? this.o8 : this.pp;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.cv) ? this.cv : this.dg;
                this.ou = this.sr != null ? this.sr : this.pa != null ? this.pa : this.pr;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cw) ? this.cw : this.dh;
                this.m0 = XInputGroup.m3(this.m4, XInputGroup.m3(this.m2, this.m6));
                this.tg = XInputGroup.tj(this.tk, XInputGroup.tj(this.ti, this.tm));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.c1) ? this.c1 : this.dm;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.c2) ? this.c2 : this.dn;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.c3) ? this.c3 : this.dp;
                this.oy = this.s9 != null ? this.s9 : this.pe != null ? this.pe : this.pw;
                this.ox = this.s8 != null ? this.s8 : this.pd != null ? this.pd : this.pv;
                this.ow = this.st != null ? this.st : this.pc != null ? this.pc : this.pu;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.c4) ? this.c4 : this.dq;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.c0) ? this.c0 : this.dl;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.cz) ? this.cz : this.dk;
                this.ov = this.ss != null ? this.ss : this.pb != null ? this.pb : this.pt;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.cx) ? this.cx : this.di;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.cy) ? this.cy : this.dj;
                break;
            case 2:
                this.ot = this.o0 != null ? this.o0 : this.o2 != null ? this.o2 : this.pi;
                this.os = this.oz != null ? this.oz : this.o1 != null ? this.o1 : this.ph;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.ck) ? this.ck : this.c5;
                this.ou = this.sr != null ? this.sr : this.o3 != null ? this.o3 : this.pj;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.cl) ? this.cl : this.c6;
                this.m0 = XInputGroup.m3(this.m4, XInputGroup.m3(this.m1, this.m5));
                this.tg = XInputGroup.tj(this.tk, XInputGroup.tj(this.th, this.tl));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.cq) ? this.cq : this.db;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.cr) ? this.cr : this.dc;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.cs) ? this.cs : this.dd;
                this.oy = this.s9 != null ? this.s9 : this.o7 != null ? this.o7 : this.po;
                this.ox = this.s8 != null ? this.s8 : this.o6 != null ? this.o6 : this.pn;
                this.ow = this.st != null ? this.st : this.o5 != null ? this.o5 : this.pm;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.ct) ? this.ct : this.de;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.cp) ? this.cp : this.da;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.co) ? this.co : this.c9;
                this.ov = this.ss != null ? this.ss : this.o4 != null ? this.o4 : this.pl;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.cm) ? this.cm : this.c7;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.cn) ? this.cn : this.c8;
                break;
            case 3:
                this.ot = this.o0 != null ? this.o0 : this.s2 != null ? this.s2 : this.si;
                this.os = this.oz != null ? this.oz : this.s1 != null ? this.s1 : this.sh;
                this.ca = !isNaN_(this.cu) ? this.cu : !isNaN_(this.hr) ? this.hr : this.gy;
                this.ou = this.sr != null ? this.sr : this.s3 != null ? this.s3 : this.sj;
                this.cb = !isNaN_(this.hc) ? this.hc : !isNaN_(this.hs) ? this.hs : this.gz;
                this.m0 = XInputGroup.m3(this.m4, XInputGroup.m3(this.nl, this.nj));
                this.tg = XInputGroup.tj(this.tk, XInputGroup.tj(this.t1, this.tz));
                this.cg = !isNaN_(this.h1) ? this.h1 : !isNaN_(this.hx) ? this.hx : this.g4;
                this.ch = !isNaN_(this.h2) ? this.h2 : !isNaN_(this.hy) ? this.hy : this.g5;
                this.ci = !isNaN_(this.h3) ? this.h3 : !isNaN_(this.hz) ? this.hz : this.g6;
                this.oy = this.s9 != null ? this.s9 : this.s7 != null ? this.s7 : this.so;
                this.ox = this.s8 != null ? this.s8 : this.s6 != null ? this.s6 : this.sn;
                this.ow = this.st != null ? this.st : this.s5 != null ? this.s5 : this.sm;
                this.cj = !isNaN_(this.h4) ? this.h4 : !isNaN_(this.h0) ? this.h0 : this.g7;
                this.cf = !isNaN_(this.hg) ? this.hg : !isNaN_(this.hw) ? this.hw : this.g3;
                this.ce = !isNaN_(this.hf) ? this.hf : !isNaN_(this.hv) ? this.hv : this.g2;
                this.ov = this.ss != null ? this.ss : this.s4 != null ? this.s4 : this.sl;
                this.cc = !isNaN_(this.hd) ? this.hd : !isNaN_(this.ht) ? this.ht : this.g0;
                this.cd = !isNaN_(this.he) ? this.he : !isNaN_(this.hu) ? this.hu : this.g1;
                break;
        }
    };
    XInputGroup.prototype.mn = function () {
        this.l4(function (a) {
        });
        this.l3(function (a) {
        });
        var a = this.view.v;
        var b = this.view.u;
        var c = this.view.x;
        var d = this.view.y;
        var e = this.p != null && this.p.playState == 1;
        var f = this.q != null && this.q.playState == 1;
        var g = this.o != null && this.o.playState == 1;
        NativeUI.m(a, this.m0);
        NativeUI.m(b, this.m0);
        NativeUI.k(a, this.os);
        NativeUI.v(a, this.tg);
        if (this.ai) {
            if (!g) {
                NativeUI.l(b, this.ou);
                NativeUI.n(b, new Thickness(0, this.cb));
            }
            if (!f) {
                NativeUI.k(c, this.ov);
            }
        }
        else {
            if (!f) {
                if (this.aj) {
                    NativeUI.k(c, this.ow);
                    NativeUI.u(c, this.ce);
                    NativeUI.r(c, this.cf);
                }
                else {
                    NativeUI.k(c, this.ox);
                    NativeUI.u(c, this.cg);
                    NativeUI.r(c, this.cj);
                }
            }
            if (!g) {
                NativeUI.l(b, this.ot);
                NativeUI.n(b, new Thickness(0, this.ca));
            }
            if (!f) {
                NativeUI.k(a, this.os);
            }
        }
        if (!e) {
            NativeUI.k(d, this.oy);
            NativeUI.r(d, this.ci);
            NativeUI.u(d, this.ch);
        }
    };
    Object.defineProperty(XInputGroup.prototype, "a", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.onChildrenMutated = function () {
        this.l3(function (a) { return a.view.az(); });
        this.l4(function (a) { return a.view.af(); });
        this.l5(function (a) { return a.view.q(); });
        this.l6(function (a) { return a.view.q(); });
    };
    XInputGroup.prototype.l1 = function () {
        this.view.af();
        var a = false;
        if (this.q == null) {
            this.q = KeyFrameAnimationFactory.f.c(this.view.c(this.a).m(new AnimationKeyFrameProperty(2, this.ot)).m(new AnimationKeyFrameProperty(2, this.ou)));
        }
        if (this.o == null) {
            this.o = KeyFrameAnimationFactory.f.c(this.view.a(this.a).m(new AnimationKeyFrameProperty(3, this.ot), new AnimationKeyFrameProperty(4, this.k == 2 || this.k == 3 ? new Thickness(0, this.ca) : new Thickness(0, 0))).m(new AnimationKeyFrameProperty(3, this.ou), new AnimationKeyFrameProperty(4, this.k == 2 || this.k == 3 ? new Thickness(0, this.cb) : new Thickness(0, 0))));
        }
        if (this.p == null) {
            this.p = KeyFrameAnimationFactory.f.c(this.view.b(this.a).m(new AnimationKeyFrameProperty(2, this.ou), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.5;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(2, this.ou), new AnimationKeyFrameProperty(14, ((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })())), new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Object.defineProperty(XInputGroup.prototype, "af", {
        get: function () {
            var a = false;
            this.l3(function (b) {
                if (b.ap) {
                    a = true;
                }
            });
            return a;
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.md = function () {
        this.ac = this.t ? this.ah : this.af ? true : false;
        this.ai = false;
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    XInputGroup.prototype.mm = function (a) {
        this.df = ThemeResolver.b(a, XInputGroup.fu, XInputGroup.d1);
        this.e5 = ThemeResolver.b(a, XInputGroup.f5, XInputGroup.ec);
        this.m7 = ThemeResolver.d(a, XInputGroup.ng, XInputGroup.na);
        this.tn = ThemeResolver.f(a, XInputGroup.tw, XInputGroup.tq);
        this.pg = ThemeResolver.e(a, XInputGroup.re, XInputGroup.py);
        this.q1 = ThemeResolver.e(a, XInputGroup.rv, XInputGroup.qf);
        this.q2 = ThemeResolver.e(a, XInputGroup.rw, XInputGroup.qg);
        this.hb = ThemeResolver.b(a, XInputGroup.gx, XInputGroup.e4);
        this.ha = ThemeResolver.b(a, XInputGroup.gw, XInputGroup.e3);
        this.e9 = ThemeResolver.b(a, XInputGroup.f9, XInputGroup.eg);
        this.sp = ThemeResolver.e(a, XInputGroup.sf, XInputGroup.qz);
        this.sq = ThemeResolver.e(a, XInputGroup.sg, XInputGroup.q0);
        this.q4 = ThemeResolver.e(a, XInputGroup.ry, XInputGroup.qi);
        this.q3 = ThemeResolver.e(a, XInputGroup.rx, XInputGroup.qh);
        this.g8 = ThemeResolver.b(a, XInputGroup.gu, XInputGroup.e1);
        this.e8 = ThemeResolver.b(a, XInputGroup.f8, XInputGroup.ef);
        this.e6 = ThemeResolver.b(a, XInputGroup.f6, XInputGroup.ed);
        this.e7 = ThemeResolver.b(a, XInputGroup.f7, XInputGroup.ee);
        this.g9 = ThemeResolver.b(a, XInputGroup.gv, XInputGroup.e2);
        this.pf = ThemeResolver.e(a, XInputGroup.rd, XInputGroup.px);
        this.fa = ThemeResolver.b(a, XInputGroup.ga, XInputGroup.eh);
        this.fb = ThemeResolver.b(a, XInputGroup.gb, XInputGroup.ei);
        this.nd = ThemeResolver.d(a, XInputGroup.nh, XInputGroup.nb);
        this.tt = ThemeResolver.f(a, XInputGroup.tx, XInputGroup.tr);
        this.q6 = ThemeResolver.e(a, XInputGroup.r0, XInputGroup.qk);
        this.q7 = ThemeResolver.e(a, XInputGroup.r1, XInputGroup.ql);
        this.q8 = ThemeResolver.e(a, XInputGroup.r2, XInputGroup.qm);
        this.fj = ThemeResolver.b(a, XInputGroup.gj, XInputGroup.eq);
        this.fi = ThemeResolver.b(a, XInputGroup.gi, XInputGroup.ep);
        this.ff = ThemeResolver.b(a, XInputGroup.gf, XInputGroup.em);
        this.rb = ThemeResolver.e(a, XInputGroup.r5, XInputGroup.qp);
        this.rc = ThemeResolver.e(a, XInputGroup.r6, XInputGroup.qq);
        this.ra = ThemeResolver.e(a, XInputGroup.r4, XInputGroup.qo);
        this.q9 = ThemeResolver.e(a, XInputGroup.r3, XInputGroup.qn);
        this.fg = ThemeResolver.b(a, XInputGroup.gg, XInputGroup.en);
        this.fe = ThemeResolver.b(a, XInputGroup.ge, XInputGroup.el);
        this.fc = ThemeResolver.b(a, XInputGroup.gc, XInputGroup.ej);
        this.fd = ThemeResolver.b(a, XInputGroup.gd, XInputGroup.ek);
        this.fh = ThemeResolver.b(a, XInputGroup.gh, XInputGroup.eo);
        this.q5 = ThemeResolver.e(a, XInputGroup.rz, XInputGroup.qj);
        this.dg = ThemeResolver.b(a, XInputGroup.fv, XInputGroup.d2);
        this.dh = ThemeResolver.b(a, XInputGroup.fw, XInputGroup.d3);
        this.m6 = ThemeResolver.d(a, XInputGroup.nf, XInputGroup.m9);
        this.tm = ThemeResolver.f(a, XInputGroup.tv, XInputGroup.tp);
        this.pq = ThemeResolver.e(a, XInputGroup.ro, XInputGroup.p8);
        this.pr = ThemeResolver.e(a, XInputGroup.rp, XInputGroup.p9);
        this.ps = ThemeResolver.e(a, XInputGroup.rq, XInputGroup.qa);
        this.dq = ThemeResolver.b(a, XInputGroup.f4, XInputGroup.eb);
        this.dp = ThemeResolver.b(a, XInputGroup.f3, XInputGroup.ea);
        this.dl = ThemeResolver.b(a, XInputGroup.f0, XInputGroup.d7);
        this.pv = ThemeResolver.e(a, XInputGroup.rt, XInputGroup.qd);
        this.pw = ThemeResolver.e(a, XInputGroup.ru, XInputGroup.qe);
        this.pu = ThemeResolver.e(a, XInputGroup.rs, XInputGroup.qc);
        this.pt = ThemeResolver.e(a, XInputGroup.rr, XInputGroup.qb);
        this.dm = ThemeResolver.b(a, XInputGroup.f1, XInputGroup.d8);
        this.dk = ThemeResolver.b(a, XInputGroup.fz, XInputGroup.d6);
        this.di = ThemeResolver.b(a, XInputGroup.fx, XInputGroup.d4);
        this.dj = ThemeResolver.b(a, XInputGroup.fy, XInputGroup.d5);
        this.dn = ThemeResolver.b(a, XInputGroup.f2, XInputGroup.d9);
        this.pp = ThemeResolver.e(a, XInputGroup.rn, XInputGroup.p7);
        this.c5 = ThemeResolver.b(a, XInputGroup.fk, XInputGroup.dr);
        this.c6 = ThemeResolver.b(a, XInputGroup.fl, XInputGroup.ds);
        this.m5 = ThemeResolver.d(a, XInputGroup.ne, XInputGroup.m8);
        this.tl = ThemeResolver.f(a, XInputGroup.tu, XInputGroup.to);
        this.pi = ThemeResolver.e(a, XInputGroup.rg, XInputGroup.p0);
        this.pj = ThemeResolver.e(a, XInputGroup.rh, XInputGroup.p1);
        this.pk = ThemeResolver.e(a, XInputGroup.ri, XInputGroup.p2);
        this.de = ThemeResolver.b(a, XInputGroup.ft, XInputGroup.d0);
        this.dd = ThemeResolver.b(a, XInputGroup.fs, XInputGroup.dz);
        this.da = ThemeResolver.b(a, XInputGroup.fp, XInputGroup.dw);
        this.pn = ThemeResolver.e(a, XInputGroup.rl, XInputGroup.p5);
        this.po = ThemeResolver.e(a, XInputGroup.rm, XInputGroup.p6);
        this.pm = ThemeResolver.e(a, XInputGroup.rk, XInputGroup.p4);
        this.pl = ThemeResolver.e(a, XInputGroup.rj, XInputGroup.p3);
        this.db = ThemeResolver.b(a, XInputGroup.fq, XInputGroup.dx);
        this.c9 = ThemeResolver.b(a, XInputGroup.fo, XInputGroup.dv);
        this.c7 = ThemeResolver.b(a, XInputGroup.fm, XInputGroup.dt);
        this.c8 = ThemeResolver.b(a, XInputGroup.fn, XInputGroup.du);
        this.dc = ThemeResolver.b(a, XInputGroup.fr, XInputGroup.dy);
        this.ph = ThemeResolver.e(a, XInputGroup.rf, XInputGroup.pz);
        this.gy = ThemeResolver.b(a, XInputGroup.gk, XInputGroup.er);
        this.gz = ThemeResolver.b(a, XInputGroup.gl, XInputGroup.es);
        this.nj = ThemeResolver.d(a, XInputGroup.ni, XInputGroup.nc);
        this.tz = ThemeResolver.f(a, XInputGroup.ty, XInputGroup.ts);
        this.si = ThemeResolver.e(a, XInputGroup.r8, XInputGroup.qs);
        this.sj = ThemeResolver.e(a, XInputGroup.r9, XInputGroup.qt);
        this.sk = ThemeResolver.e(a, XInputGroup.sa, XInputGroup.qu);
        this.g7 = ThemeResolver.b(a, XInputGroup.gt, XInputGroup.e0);
        this.g6 = ThemeResolver.b(a, XInputGroup.gs, XInputGroup.ez);
        this.g3 = ThemeResolver.b(a, XInputGroup.gp, XInputGroup.ew);
        this.sn = ThemeResolver.e(a, XInputGroup.sd, XInputGroup.qx);
        this.so = ThemeResolver.e(a, XInputGroup.se, XInputGroup.qy);
        this.sm = ThemeResolver.e(a, XInputGroup.sc, XInputGroup.qw);
        this.sl = ThemeResolver.e(a, XInputGroup.sb, XInputGroup.qv);
        this.g4 = ThemeResolver.b(a, XInputGroup.gq, XInputGroup.ex);
        this.g2 = ThemeResolver.b(a, XInputGroup.go, XInputGroup.ev);
        this.g0 = ThemeResolver.b(a, XInputGroup.gm, XInputGroup.et);
        this.g1 = ThemeResolver.b(a, XInputGroup.gn, XInputGroup.eu);
        this.g5 = ThemeResolver.b(a, XInputGroup.gr, XInputGroup.ey);
        this.sh = ThemeResolver.e(a, XInputGroup.r7, XInputGroup.qr);
    };
    XInputGroup.prototype.l7 = function () {
        var _this = this;
        this.l1();
        if (this.ac) {
            this.l4(function (a) { return a.ck(true, !_this.ad); });
            this.l3(function (a) { return a.dh(_this.al, !_this.ad); });
        }
        else {
            this.l4(function (a) { return a.ck(false, !_this.ad); });
            this.l3(function (a) { return a.dh(_this.al, !_this.ad); });
        }
    };
    XInputGroup.prototype.mc = function () {
        this.l1();
        if (this.ai) {
            var a = 1;
            this.l4(function (b) { return b.al = true; });
            this.mg(a);
        }
        else {
            var b = -1;
            this.l4(function (c) { return c.al = false; });
            this.mg(b);
        }
    };
    XInputGroup.prototype.mb = function () {
        this.ac = this.t ? this.ah : true;
        this.ai = true;
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    XInputGroup.prototype.mt = function () {
        if (this.t) {
            this.ac = this.t;
        }
        else if (this.ai) {
            this.ac = true;
        }
        else {
            this.ac = this.af ? true : false;
        }
    };
    XInputGroup.prototype.mg = function (a) {
        var _this = this;
        if ((a > 0 && this.q.playbackRate < 0) || (a < 0 && this.q.playbackRate > 0)) {
            this.q.reverse();
            this.q.finished.f(function (b) {
                if (_this.q != null) {
                    _this.q.commitStyles();
                }
                if (_this.ab) {
                    _this.q = null;
                    _this.ab = false;
                }
            });
            this.o.reverse();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.s) {
                    _this.o = null;
                    _this.s = false;
                }
            });
            this.p.reverse();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
        }
        else {
            this.q.play();
            this.q.finished.f(function (b) {
                if (_this.q != null) {
                    _this.q.commitStyles();
                }
                if (_this.ab) {
                    _this.q = null;
                    _this.ab = false;
                }
            });
            this.o.play();
            this.o.finished.f(function (b) {
                if (_this.o != null) {
                    _this.o.commitStyles();
                }
                if (_this.s) {
                    _this.o = null;
                    _this.s = false;
                }
            });
            this.p.play();
            this.p.finished.f(function (b) {
                if (_this.p != null) {
                    _this.p.commitStyles();
                }
                if (_this.aa) {
                    _this.p = null;
                    _this.aa = false;
                }
            });
        }
    };
    Object.defineProperty(XInputGroup.prototype, "ot", {
        get: function () {
            return this.nn;
        },
        set: function (a) {
            var b = this.nn;
            this.nn = a;
            if (b != this.nn) {
                this.me("ActualBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ou", {
        get: function () {
            return this.no;
        },
        set: function (a) {
            var b = this.no;
            this.no = a;
            if (b != this.no) {
                this.me("ActualFocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ca", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.me("ActualBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cb", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (b != this.an) {
                this.me("ActualFocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "m0", {
        get: function () {
            return this.mu;
        },
        set: function (a) {
            var b = this.mu;
            this.mu = a;
            if (b != this.mu) {
                this.me("ActualCornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "tg", {
        get: function () {
            return this.ta;
        },
        set: function (a) {
            var b = this.ta;
            this.ta = a;
            if (b != this.ta) {
                this.me("ActualContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cj", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.me("ActualUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ci", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (b != this.au) {
                this.me("ActualUnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cf", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (b != this.ar) {
                this.me("ActualHoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ox", {
        get: function () {
            return this.nr;
        },
        set: function (a) {
            var b = this.nr;
            this.nr = a;
            if (b != this.nr) {
                this.me("ActualUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "oy", {
        get: function () {
            return this.ns;
        },
        set: function (a) {
            var b = this.ns;
            this.ns = a;
            if (b != this.ns) {
                this.me("ActualUnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ow", {
        get: function () {
            return this.nq;
        },
        set: function (a) {
            var b = this.nq;
            this.nq = a;
            if (b != this.nq) {
                this.me("ActualHoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ov", {
        get: function () {
            return this.np;
        },
        set: function (a) {
            var b = this.np;
            this.oa = a;
            if (b != this.np) {
                this.me("ActualFocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cg", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.me("ActualUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ce", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (b != this.aq) {
                this.me("ActualHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cc", {
        get: function () {
            return this.ao;
        },
        set: function (a) {
            var b = this.ao;
            this.ao = a;
            if (b != this.ao) {
                this.me("ActualFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cd", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            if (b != this.ap) {
                this.me("ActualFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ch", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.me("ActualUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "os", {
        get: function () {
            return this.nm;
        },
        set: function (a) {
            var b = this.nm;
            this.nm = a;
            if (b != this.nm) {
                this.me("ActualBackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cu", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.me("BorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hc", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.me("FocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o0", {
        get: function () {
            return this.nu;
        },
        set: function (a) {
            var b = this.nu;
            this.nu = a;
            if (b != this.nu) {
                this.me("BorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "m4", {
        get: function () {
            return this.mx;
        },
        set: function (a) {
            var b = this.mx;
            this.mx = a;
            if (b != this.mx) {
                this.me("CornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "tk", {
        get: function () {
            return this.td;
        },
        set: function (a) {
            var b = this.td;
            this.td = a;
            if (b != this.td) {
                this.me("ContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h4", {
        get: function () {
            return this.b9;
        },
        set: function (a) {
            var b = this.b9;
            this.b9 = a;
            if (b != this.b9) {
                this.me("UnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h3", {
        get: function () {
            return this.b8;
        },
        set: function (a) {
            var b = this.b8;
            this.b8 = a;
            if (b != this.b8) {
                this.me("UnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hg", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.me("HoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s8", {
        get: function () {
            return this.oq;
        },
        set: function (a) {
            var b = this.oq;
            this.oq = a;
            if (b != this.oq) {
                this.me("UnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s9", {
        get: function () {
            return this.or;
        },
        set: function (a) {
            var b = this.or;
            this.or = a;
            if (b != this.or) {
                this.me("UnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "st", {
        get: function () {
            return this.ob;
        },
        set: function (a) {
            var b = this.ob;
            this.ob = a;
            if (b != this.ob) {
                this.me("HoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ss", {
        get: function () {
            return this.oa;
        },
        set: function (a) {
            var b = this.oa;
            this.oa = a;
            if (b != this.oa) {
                this.me("FocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h1", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            var b = this.b6;
            this.b6 = a;
            if (b != this.b6) {
                this.me("UnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hf", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.me("HoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hd", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.me("FocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "he", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.me("FocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h2", {
        get: function () {
            return this.b7;
        },
        set: function (a) {
            var b = this.b7;
            this.b7 = a;
            if (b != this.b7) {
                this.me("UnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "oz", {
        get: function () {
            return this.nt;
        },
        set: function (a) {
            var b = this.nt;
            this.nt = a;
            if (b != this.nt) {
                this.me("BackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hh", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.me("LineTypeBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hi", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.me("LineTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sw", {
        get: function () {
            return this.oe;
        },
        set: function (a) {
            var b = this.oe;
            this.oe = a;
            if (b != this.oe) {
                this.me("LineTypeFocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sv", {
        get: function () {
            return this.od;
        },
        set: function (a) {
            var b = this.od;
            this.od = a;
            if (b != this.od) {
                this.me("LineTypeBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "nk", {
        get: function () {
            return this.my;
        },
        set: function (a) {
            var b = this.my;
            this.my = a;
            if (b != this.my) {
                this.me("LineTypeCornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "t0", {
        get: function () {
            return this.te;
        },
        set: function (a) {
            var b = this.te;
            this.te = a;
            if (b != this.te) {
                this.me("LineTypeContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hq", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (b != this.bv) {
                this.me("LineTypeUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hp", {
        get: function () {
            return this.bu;
        },
        set: function (a) {
            var b = this.bu;
            this.bu = a;
            if (b != this.bu) {
                this.me("LineTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hm", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (b != this.br) {
                this.me("LineTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sz", {
        get: function () {
            return this.oh;
        },
        set: function (a) {
            var b = this.oh;
            this.oh = a;
            if (b != this.oh) {
                this.me("LineTypeUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s0", {
        get: function () {
            return this.oi;
        },
        set: function (a) {
            var b = this.oi;
            this.oi = a;
            if (b != this.oi) {
                this.me("LineTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sy", {
        get: function () {
            return this.og;
        },
        set: function (a) {
            var b = this.og;
            this.ob = a;
            if (b != this.og) {
                this.me("LineTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sx", {
        get: function () {
            return this.of;
        },
        set: function (a) {
            var b = this.of;
            this.of = a;
            if (b != this.of) {
                this.me("LineTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hn", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (b != this.bs) {
                this.me("LineTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hl", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (b != this.bq) {
                this.me("LineTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hj", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.me("LineTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hk", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (b != this.bp) {
                this.me("LineTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ho", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (b != this.bt) {
                this.me("LineTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "su", {
        get: function () {
            return this.oc;
        },
        set: function (a) {
            var b = this.oc;
            this.oc = a;
            if (b != this.oc) {
                this.me("LineTypeBackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cv", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.me("BoxTypeBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cw", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.me("BoxTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "pa", {
        get: function () {
            return this.n4;
        },
        set: function (a) {
            var b = this.n4;
            this.n4 = a;
            if (b != this.n4) {
                this.me("BoxTypeFocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o9", {
        get: function () {
            return this.n3;
        },
        set: function (a) {
            var b = this.n3;
            this.n3 = a;
            if (b != this.n3) {
                this.me("BoxTypeBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "m2", {
        get: function () {
            return this.mw;
        },
        set: function (a) {
            var b = this.mw;
            this.mw = a;
            if (b != this.mw) {
                this.me("BoxTypeCornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ti", {
        get: function () {
            return this.tc;
        },
        set: function (a) {
            var b = this.tc;
            this.tc = a;
            if (b != this.tc) {
                this.me("BoxTypeContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "c4", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.me("BoxTypeUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "c3", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.me("BoxTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "c0", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.me("BoxTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "pd", {
        get: function () {
            return this.n7;
        },
        set: function (a) {
            var b = this.n7;
            this.n7 = a;
            if (b != this.n7) {
                this.me("BoxTypeUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "pe", {
        get: function () {
            return this.n8;
        },
        set: function (a) {
            var b = this.n8;
            this.n8 = a;
            if (b != this.n8) {
                this.me("BoxTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "pc", {
        get: function () {
            return this.n6;
        },
        set: function (a) {
            var b = this.n6;
            this.ob = a;
            if (b != this.n6) {
                this.me("BoxTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "pb", {
        get: function () {
            return this.n5;
        },
        set: function (a) {
            var b = this.n5;
            this.n5 = a;
            if (b != this.n5) {
                this.me("BoxTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "c1", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            if (b != this.bd) {
                this.me("BoxTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cz", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.me("BoxTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cx", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.me("BoxTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cy", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            if (b != this.ba) {
                this.me("BoxTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "c2", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.me("BoxTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o8", {
        get: function () {
            return this.n2;
        },
        set: function (a) {
            var b = this.n2;
            this.n2 = a;
            if (b != this.n2) {
                this.me("BoxTypeBackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ck", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.me("BorderTypeBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cl", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.me("BorderTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o3", {
        get: function () {
            return this.nx;
        },
        set: function (a) {
            var b = this.nx;
            this.nx = a;
            if (b != this.nx) {
                this.me("BorderTypeFocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o2", {
        get: function () {
            return this.nw;
        },
        set: function (a) {
            var b = this.nw;
            this.nw = a;
            if (b != this.nw) {
                this.me("BorderTypeBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "m1", {
        get: function () {
            return this.mv;
        },
        set: function (a) {
            var b = this.mv;
            this.mv = a;
            if (b != this.mv) {
                this.me("BorderTypeCornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "th", {
        get: function () {
            return this.tb;
        },
        set: function (a) {
            var b = this.tb;
            this.tb = a;
            if (b != this.tb) {
                this.me("BorderTypeContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ct", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.me("BorderTypeUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cs", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.me("BorderTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cp", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.me("BorderTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o6", {
        get: function () {
            return this.n0;
        },
        set: function (a) {
            var b = this.n0;
            this.n0 = a;
            if (b != this.n0) {
                this.me("BorderTypeUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o7", {
        get: function () {
            return this.n1;
        },
        set: function (a) {
            var b = this.n1;
            this.n1 = a;
            if (b != this.n1) {
                this.me("BorderTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o5", {
        get: function () {
            return this.nz;
        },
        set: function (a) {
            var b = this.nz;
            this.ob = a;
            if (b != this.nz) {
                this.me("BorderTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o4", {
        get: function () {
            return this.ny;
        },
        set: function (a) {
            var b = this.ny;
            this.ny = a;
            if (b != this.ny) {
                this.me("BorderTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cq", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.me("BorderTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "co", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (b != this.a0) {
                this.me("BorderTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cm", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.me("BorderTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cn", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.me("BorderTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "cr", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (b != this.a3) {
                this.me("BorderTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "o1", {
        get: function () {
            return this.nv;
        },
        set: function (a) {
            var b = this.nv;
            this.nv = a;
            if (b != this.nv) {
                this.me("BorderTypeBackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hr", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            var b = this.bw;
            this.bw = a;
            if (b != this.bw) {
                this.me("SearchTypeBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hs", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            if (b != this.bx) {
                this.me("SearchTypeFocusBorderWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s3", {
        get: function () {
            return this.ol;
        },
        set: function (a) {
            var b = this.ol;
            this.ol = a;
            if (b != this.ol) {
                this.me("SearchTypeFocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s2", {
        get: function () {
            return this.ok;
        },
        set: function (a) {
            var b = this.ok;
            this.ok = a;
            if (b != this.ok) {
                this.me("SearchTypeBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "nl", {
        get: function () {
            return this.mz;
        },
        set: function (a) {
            var b = this.mz;
            this.mz = a;
            if (b != this.mz) {
                this.me("SearchTypeCornerRadius", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "t1", {
        get: function () {
            return this.tf;
        },
        set: function (a) {
            var b = this.tf;
            this.tf = a;
            if (b != this.tf) {
                this.me("SearchTypeContentPadding", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h0", {
        get: function () {
            return this.b5;
        },
        set: function (a) {
            var b = this.b5;
            this.b5 = a;
            if (b != this.b5) {
                this.me("SearchTypeUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hz", {
        get: function () {
            return this.b4;
        },
        set: function (a) {
            var b = this.b4;
            this.b4 = a;
            if (b != this.b4) {
                this.me("SearchTypeUnderlineRippleWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hw", {
        get: function () {
            return this.b1;
        },
        set: function (a) {
            var b = this.b1;
            this.b1 = a;
            if (b != this.b1) {
                this.me("SearchTypeHoverUnderlineWidth", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s6", {
        get: function () {
            return this.oo;
        },
        set: function (a) {
            var b = this.oo;
            this.oo = a;
            if (b != this.oo) {
                this.me("SearchTypeUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s7", {
        get: function () {
            return this.op;
        },
        set: function (a) {
            var b = this.op;
            this.op = a;
            if (b != this.op) {
                this.me("SearchTypeUnderlineRippleColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s5", {
        get: function () {
            return this.on;
        },
        set: function (a) {
            var b = this.on;
            this.ob = a;
            if (b != this.on) {
                this.me("SearchTypeHoverUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s4", {
        get: function () {
            return this.om;
        },
        set: function (a) {
            var b = this.om;
            this.om = a;
            if (b != this.om) {
                this.me("SearchTypeFocusUnderlineColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hx", {
        get: function () {
            return this.b2;
        },
        set: function (a) {
            var b = this.b2;
            this.b2 = a;
            if (b != this.b2) {
                this.me("SearchTypeUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hv", {
        get: function () {
            return this.b0;
        },
        set: function (a) {
            var b = this.b0;
            this.b0 = a;
            if (b != this.b0) {
                this.me("SearchTypeHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ht", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            if (b != this.by) {
                this.me("SearchTypeFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hu", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            if (b != this.bz) {
                this.me("SearchTypeFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "hy", {
        get: function () {
            return this.b3;
        },
        set: function (a) {
            var b = this.b3;
            this.b3 = a;
            if (b != this.b3) {
                this.me("SearchTypeUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "s1", {
        get: function () {
            return this.oj;
        },
        set: function (a) {
            var b = this.oj;
            this.oj = a;
            if (b != this.oj) {
                this.me("SearchTypeBackgroundColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ah", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            var b = this.x;
            this.x = a;
            if (b != this.x) {
                this.me("IsExpanded", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.mk = function () {
        this.x = false;
        this.t = false;
        this.mt();
    };
    Object.defineProperty(XInputGroup.prototype, "aj", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.me("IsHovered", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ai", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.me("IsFocused", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ac", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            if (b != this.r) {
                this.me("ActualIsExpanded", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "sr", {
        get: function () {
            return this.n9;
        },
        set: function (a) {
            var b = this.n9;
            this.n9 = a;
            if (b != this.n9) {
                this.me("FocusBorderColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "ki", {
        get: function () {
            return this.ib;
        },
        set: function (a) {
            var b = this.ib;
            this.ib = a;
            if (b != this.ib) {
                this.me("Id", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "disabled", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (b != this.w) {
                this.me("IsDisabled", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.mf = function () {
    };
    XInputGroup.prototype.onDetachedFromUI = function () {
        this.view.ai();
    };
    XInputGroup.prototype.onAttachedToUI = function () {
        this.view.ag();
    };
    XInputGroup.prototype.ensureShift = function () {
        this.l3(function (a) { return a.view.az(); });
        this.l4(function (a) { return a.view.af(); });
        this.l5(function (a) { return a.view.q(); });
        this.l6(function (a) { return a.view.q(); });
    };
    XInputGroup.prototype.ak = function () {
        return this.view.g();
    };
    XInputGroup.prototype.ia = function () {
        return this.i();
    };
    XInputGroup.prototype.j9 = function () {
        var a = this.i();
        return a.y();
    };
    XInputGroup.prototype.i = function () {
        var a = new InputGroupVisualModelExport();
        a.f = this.g;
        a.e = this.d;
        a.b = AppearanceHelper.a(this.ot);
        a.o = this.ca;
        a.p = this.cb;
        a.z = this.m0;
        a.aa = this.tg;
        a.x = this.cj;
        a.w = this.ci;
        a.t = this.cf;
        a.c = AppearanceHelper.a(this.ox);
        a.d = AppearanceHelper.a(this.oy);
        a.u = this.cg;
        a.s = this.ce;
        a.q = this.cc;
        a.r = this.cd;
        a.v = this.ch;
        a.a = AppearanceHelper.a(this.os);
        a.g = this.ac;
        a.j = this.aj;
        a.i = this.ai;
        a.h = this.disabled;
        a.m = new List$1(PrefixVisualModelExport.$, 0);
        a.l = new List$1(LabelVisualModelExport.$, 0);
        a.k = new List$1(InputVisualModelExport.$, 0);
        a.n = new List$1(SuffixVisualModelExport.$, 0);
        for (var b = 0; b < this.inputs.count; b++) {
            if (typeCast(XPrefix.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Prefix" + a.m.count.toString();
                }
                a.m.add1(this.inputs._inner[b].t());
            }
            else if (typeCast(XLabel.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Label" + a.l.count.toString();
                }
                a.l.add1(this.inputs._inner[b].au());
            }
            else if (typeCast(XInput.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Input" + a.k.count.toString();
                }
                a.k.add1(this.inputs._inner[b].bc());
            }
            else if (typeCast(XSuffix.$, this.inputs._inner[b]) !== null) {
                if (this.inputs._inner[b].e == null) {
                    this.inputs._inner[b].e = "Suffix" + a.n.count.toString();
                }
                a.n.add1(this.inputs._inner[b].t());
            }
        }
        return a;
    };
    XInputGroup.prototype.provideContainer = function (a) {
        this.view.ah(a);
    };
    Object.defineProperty(XInputGroup.prototype, "inputs", {
        get: function () {
            return this.l;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "h7", {
        get: function () {
            if (!this.h9.hasValue) {
                var a_1 = 0;
                this.l4(function (b) { return a_1++; });
                this.h9 = toNullable(Number_$type, a_1);
            }
            return this.h9.value;
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.prototype.ml = function () {
        this.h9 = toNullable(Number_$type, null);
    };
    Object.defineProperty(XInputGroup.prototype, "ae", {
        get: function () {
            return this.h7 > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInputGroup.prototype, "al", {
        get: function () {
            return !this.ae || this.ac;
        },
        enumerable: false,
        configurable: true
    });
    XInputGroup.$t = markType(XInputGroup, 'XInputGroup', Base.$, [INotifyPropertyChanged_$type]);
    XInputGroup.c = 2;
    XInputGroup.fu = 0;
    XInputGroup.f5 = 0;
    XInputGroup.ng = new CornerRadius(1, 0, 0, 0, 0);
    XInputGroup.tw = new Thickness(1, 0, 0, 0, 0);
    XInputGroup.re = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rv = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.rw = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gx = 1;
    XInputGroup.gw = 2;
    XInputGroup.f9 = 2;
    XInputGroup.sf = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.sg = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.ry = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rx = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gu = 1;
    XInputGroup.f8 = 1;
    XInputGroup.f6 = 1;
    XInputGroup.f7 = 1;
    XInputGroup.gv = 0;
    XInputGroup.rd = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.ga = 0;
    XInputGroup.gb = 0;
    XInputGroup.nh = new CornerRadius(1, 0, 0, 0, 0);
    XInputGroup.tx = new Thickness(1, 0, 0, 0, 0);
    XInputGroup.r0 = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.r1 = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.r2 = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gj = 1;
    XInputGroup.gi = 2;
    XInputGroup.gf = 2;
    XInputGroup.r5 = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.r6 = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.r4 = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.r3 = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gg = 1;
    XInputGroup.ge = 1;
    XInputGroup.gc = 1;
    XInputGroup.gd = 1;
    XInputGroup.gh = 0;
    XInputGroup.rz = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.fv = 0;
    XInputGroup.fw = 0;
    XInputGroup.nf = new CornerRadius(1, 4, 4, 0, 0);
    XInputGroup.tv = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.ro = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rp = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.rq = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.f4 = 1;
    XInputGroup.f3 = 2;
    XInputGroup.f0 = 2;
    XInputGroup.rt = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.ru = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.rs = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rr = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.f1 = 1;
    XInputGroup.fz = 1;
    XInputGroup.fx = 1;
    XInputGroup.fy = 1;
    XInputGroup.f2 = 0;
    XInputGroup.rn = BrushUtil.g(20, 0, 0, 0);
    XInputGroup.fk = 1;
    XInputGroup.fl = 2;
    XInputGroup.ne = new CornerRadius(1, 4, 4, 4, 4);
    XInputGroup.tu = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.rg = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rh = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.ri = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.ft = 1;
    XInputGroup.fs = 2;
    XInputGroup.fp = 2;
    XInputGroup.rl = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rm = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.rk = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.rj = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.fq = 0;
    XInputGroup.fo = 0;
    XInputGroup.fm = 0;
    XInputGroup.fn = 0;
    XInputGroup.fr = 0;
    XInputGroup.rf = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.gk = 1;
    XInputGroup.gl = 2;
    XInputGroup.ni = new CornerRadius(1, 4, 4, 4, 4);
    XInputGroup.ty = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.r8 = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.r9 = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.sa = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gt = 1;
    XInputGroup.gs = 2;
    XInputGroup.gp = 2;
    XInputGroup.sd = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.se = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.sc = BrushUtil.g(138, 0, 0, 0);
    XInputGroup.sb = BrushUtil.g(255, 0, 153, 155);
    XInputGroup.gq = 0;
    XInputGroup.go = 0;
    XInputGroup.gm = 0;
    XInputGroup.gn = 0;
    XInputGroup.gr = 0;
    XInputGroup.r7 = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.d1 = 0;
    XInputGroup.ec = 0;
    XInputGroup.na = new CornerRadius(1, 0, 0, 0, 0);
    XInputGroup.tq = new Thickness(1, 0, 0, 0, 0);
    XInputGroup.py = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qf = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qg = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.e4 = 1;
    XInputGroup.e3 = 2;
    XInputGroup.eg = 2;
    XInputGroup.qz = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.q0 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qi = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qh = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.e1 = 1;
    XInputGroup.ef = 1;
    XInputGroup.ed = 1;
    XInputGroup.ee = 1;
    XInputGroup.e2 = 0;
    XInputGroup.px = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.eh = 0;
    XInputGroup.ei = 0;
    XInputGroup.nb = new CornerRadius(1, 0, 0, 0, 0);
    XInputGroup.tr = new Thickness(1, 0, 0, 0, 0);
    XInputGroup.qk = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.ql = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qm = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.eq = 1;
    XInputGroup.ep = 2;
    XInputGroup.em = 2;
    XInputGroup.qp = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qq = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qo = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qn = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.en = 1;
    XInputGroup.el = 1;
    XInputGroup.ej = 1;
    XInputGroup.ek = 1;
    XInputGroup.eo = 0;
    XInputGroup.qj = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.d2 = 0;
    XInputGroup.d3 = 0;
    XInputGroup.m9 = new CornerRadius(1, 4, 4, 0, 0);
    XInputGroup.tp = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.p8 = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.p9 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qa = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.eb = 1;
    XInputGroup.ea = 2;
    XInputGroup.d7 = 2;
    XInputGroup.qd = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qe = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qc = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qb = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.d8 = 1;
    XInputGroup.d6 = 1;
    XInputGroup.d4 = 1;
    XInputGroup.d5 = 1;
    XInputGroup.d9 = 0;
    XInputGroup.p7 = BrushUtil.g(20, 0, 0, 0);
    XInputGroup.dr = 1;
    XInputGroup.ds = 2;
    XInputGroup.m8 = new CornerRadius(1, 4, 4, 4, 4);
    XInputGroup.to = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.p0 = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.p1 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.p2 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.d0 = 1;
    XInputGroup.dz = 2;
    XInputGroup.dw = 2;
    XInputGroup.p5 = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.p6 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.p4 = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.p3 = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.dx = 0;
    XInputGroup.dv = 0;
    XInputGroup.dt = 0;
    XInputGroup.du = 0;
    XInputGroup.dy = 0;
    XInputGroup.pz = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.er = 1;
    XInputGroup.es = 2;
    XInputGroup.nc = new CornerRadius(1, 4, 4, 4, 4);
    XInputGroup.ts = new Thickness(1, 16, 0, 16, 0);
    XInputGroup.qs = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qt = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qu = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.e0 = 1;
    XInputGroup.ez = 2;
    XInputGroup.ew = 2;
    XInputGroup.qx = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qy = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.qw = BrushUtil.g(255, 186, 191, 199);
    XInputGroup.qv = BrushUtil.g(255, 33, 150, 243);
    XInputGroup.ex = 0;
    XInputGroup.ev = 0;
    XInputGroup.et = 0;
    XInputGroup.eu = 0;
    XInputGroup.ey = 0;
    XInputGroup.qr = BrushUtil.g(0, 0, 0, 0);
    XInputGroup.h8 = 0;
    return XInputGroup;
}(Base));
export { XInputGroup };
/**
 * @hidden
 */
var XInputGroupInputCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XInputGroupInputCollection, _super);
    function XInputGroupInputCollection() {
        var _this = _super.call(this, XInputGroupItem.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    XInputGroupInputCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    XInputGroupInputCollection.$t = markType(XInputGroupInputCollection, 'XInputGroupInputCollection', ObservableCollection$1.$.specialize(XInputGroupItem.$));
    return XInputGroupInputCollection;
}(ObservableCollection$1));
export { XInputGroupInputCollection };
/**
 * @hidden
 */
var XLabel = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XLabel, _super);
    function XLabel() {
        var _this = _super.call(this) || this;
        _this.j = 0;
        _this._view = null;
        _this.aa = null;
        _this.z = null;
        _this.n = 0;
        _this.m = 1;
        _this.cr = ThemeResolver.e(XLabel.k, XLabel.da, XLabel.c3);
        _this.co = ThemeResolver.e(XLabel.k, XLabel.c7, XLabel.c0);
        _this.cp = ThemeResolver.e(XLabel.k, XLabel.c8, XLabel.c1);
        _this.cq = ThemeResolver.e(XLabel.k, XLabel.c9, XLabel.c2);
        _this.u = null;
        _this.cv = XLabel.db;
        _this.cs = XLabel.c4;
        _this.ct = XLabel.c5;
        _this.r = 0;
        _this.af = false;
        _this.ad = false;
        _this.v = null;
        _this.cu = null;
        _this.a2 = "ig-label-" + XLabel.at++;
        _this.ay = "inline-block";
        _this.az = "inline-block";
        _this.a0 = null;
        _this.av = "center";
        _this.aw = "center";
        _this.ar = 0;
        _this.ab = false;
        _this.a1 = null;
        _this.ax = null;
        _this.a3 = null;
        _this.ae = false;
        _this.ai = false;
        _this.ac = false;
        _this.ah = false;
        _this.ag = false;
        _this.ap = false;
        var a = new LabelView();
        a.c = _this;
        _this.view = a;
        _this.view.ab();
        return _this;
    }
    Object.defineProperty(XLabel.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: false,
        configurable: true
    });
    XLabel.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(XLabel.prototype, "i", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: false,
        configurable: true
    });
    XLabel.prototype.b8 = function () {
        var _this = this;
        this.view.s();
        var a = false;
        if (this.aa == null) {
            var b = new TransformGroup();
            b.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.view.j();
                return $ret;
            })()));
            b.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 1;
                $ret.m = 1;
                return $ret;
            })()));
            var c_1 = -(this.view.i() * 1.3);
            if (this.o == 2) {
                c_1 = -(this.view.i() * 1.05);
            }
            if (this.o == 3) {
                c_1 = -(this.view.i() * 1.01);
            }
            var d = new TransformGroup();
            d.j.add(((function () {
                var $ret = new TranslateTransform();
                $ret.k = _this.s == 2 ? c_1 : -(_this.view.i() * 0.65);
                return $ret;
            })()));
            d.j.add(((function () {
                var $ret = new ScaleTransform();
                $ret.l = 0.75;
                $ret.m = 0.75;
                return $ret;
            })()));
            this.aa = KeyFrameAnimationFactory.f.c(this.view.b(this.i).m(new AnimationKeyFrameProperty(14, b), new AnimationKeyFrameProperty(2, BrushUtil.g(0, 255, 255, 255))).m(new AnimationKeyFrameProperty(14, d), new AnimationKeyFrameProperty(2, BrushUtil.g(this.s == 2 ? 255 : 0, 255, 255, 255))));
        }
        if (this.z == null) {
            this.z = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(7, this.cz)).m(new AnimationKeyFrameProperty(7, this.cw)));
        }
    };
    XLabel.prototype.ci = function (a, b) {
        var _this = this;
        if ((b > 0 && a.playbackRate < 0) || (b < 0 && a.playbackRate > 0)) {
            a.reverse();
            if (this.ap) {
                a.finish();
                this.b9(a);
                return;
            }
            a.finished.f(function (c) { return _this.b9(a); });
        }
        else {
            a.play();
            if (this.ap) {
                a.finish();
                this.b9(a);
                return;
            }
            a.finished.f(function (c) { return _this.b9(a); });
        }
    };
    XLabel.prototype.b9 = function (a) {
        a.commitStyles();
        if (a == this.aa && this.ah) {
            this.aa = null;
        }
        if (a == this.z && this.ag) {
            this.z = null;
        }
    };
    XLabel.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "BaseTheme":
                this.cl(this.l);
                this.cn();
                break;
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
            case "HighlightTextColor":
            case "HoverHighlightTextColor":
                this.cn();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
            case "ActualHighlightTextColor":
            case "ActualHoverHighlightTextColor":
                if (this.aa != null) {
                    if (this.aa.playState == 3) {
                        this.aa = null;
                    }
                    else {
                        this.ah = true;
                    }
                }
                if (this.z != null) {
                    if (this.z.playState == 3) {
                        this.z = null;
                    }
                    else {
                        this.ag = true;
                    }
                }
                this.cm();
                break;
            case "Text":
                this.view.ae();
                break;
            case "Density":
                this.o = this.p == 0 ? 1 : this.p;
                break;
            case "ActualDensity":
                this.view.ag();
                this.view.af();
                break;
            case "InputGroup":
                this.view.af();
                break;
            case "IsHighlighted":
                this.cc();
                break;
            case "IsShifted":
                this.cd();
                break;
            case "ShiftType":
                if (this.aa != null) {
                    if (this.aa.playState == 3) {
                        this.aa = null;
                    }
                    else {
                        this.ah = true;
                    }
                }
                this.cg();
                break;
            case "Display":
                this.view.y();
                break;
            case "FlexDirection":
                this.view.z();
                break;
            case "FlexGrow":
                this.view.aa();
                break;
            case "AlignItems":
                this.view.t();
                break;
            case "AlignSelf":
                this.view.u();
                break;
        }
    };
    XLabel.prototype.cg = function () {
        this.view.af();
    };
    XLabel.prototype.cd = function () {
        this.b8();
        var a = 1;
        var b = this.an;
        if (!b) {
            a = -1;
        }
        this.ci(this.aa, a);
    };
    XLabel.prototype.cc = function () {
        this.b8();
        var a = 1;
        var b = this.al;
        if (!b) {
            a = -1;
        }
        this.ci(this.z, a);
    };
    XLabel.prototype.cn = function () {
        this.cz = this.df != null ? this.df : XLabel.db;
        this.cy = this.de != null ? this.de : XLabel.db;
        this.cw = this.dc != null ? this.dc : XLabel.c4;
        this.w = this.y != null ? this.y : XLabel.x;
    };
    XLabel.prototype.cm = function () {
        if (this.w != null) {
            this.view.ai(this.w);
        }
        this.view.ad(this.cz);
    };
    XLabel.prototype.cl = function (a) {
        XLabel.db = ThemeResolver.e(a, XLabel.da, XLabel.c3);
        XLabel.c4 = ThemeResolver.e(a, XLabel.c7, XLabel.c0);
        XLabel.c6 = ThemeResolver.e(a, XLabel.c9, XLabel.c2);
        XLabel.c5 = ThemeResolver.e(a, XLabel.c8, XLabel.c1);
    };
    Object.defineProperty(XLabel.prototype, "p", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "cz", {
        get: function () {
            return this.cr;
        },
        set: function (a) {
            var b = this.cr;
            this.cr = a;
            if (b != this.cr) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "cw", {
        get: function () {
            return this.co;
        },
        set: function (a) {
            var b = this.co;
            this.co = a;
            if (b != this.co) {
                this.g("ActualHighlightTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "cx", {
        get: function () {
            return this.cp;
        },
        set: function (a) {
            var b = this.cp;
            this.cp = a;
            if (b != this.cp) {
                this.g("ActualHoverHighlightTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "cy", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            var b = this.cq;
            this.cq = a;
            if (b != this.cq) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "df", {
        get: function () {
            return this.cv;
        },
        set: function (a) {
            var b = this.cv;
            this.cv = a;
            if (b != this.cv) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "dc", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (b != this.cs) {
                this.g("HighlightTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "dd", {
        get: function () {
            return this.ct;
        },
        set: function (a) {
            var b = this.ct;
            this.ct = a;
            if (b != this.ct) {
                this.g("HoverHighlightTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "s", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            if (b != this.r) {
                this.g("ShiftType", enumGetBox(LabelShiftType_$type, b), enumGetBox(LabelShiftType_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "an", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            var b = this.af;
            this.af = a;
            if (b != this.af) {
                this.g("IsShifted", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XLabel.prototype.ck = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = this.ap;
        if (!b) {
            this.ap = true;
        }
        try {
            this.an = a;
        }
        finally {
            if (!b) {
                this.ap = c;
            }
        }
    };
    Object.defineProperty(XLabel.prototype, "al", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (b != this.ad) {
                this.g("IsHighlighted", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XLabel.prototype.ce = function () {
        this.am = true;
    };
    XLabel.prototype.cf = function () {
        this.am = false;
    };
    Object.defineProperty(XLabel.prototype, "y", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (b != this.v) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "de", {
        get: function () {
            return this.cu;
        },
        set: function (a) {
            var b = this.cu;
            this.cu = a;
            if (b != this.cu) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bu", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (b != this.a2) {
                this.g("Id", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bi", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.g("Display", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bl", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (b != this.az) {
                this.g("FlexDirection", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bn", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (b != this.a0) {
                this.g("FlexGrow", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "ba", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            if (b != this.av) {
                this.g("AlignItems", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bc", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.g("AlignSelf", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "aj", {
        get: function () {
            return this.ab;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "as", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            this.ab = true;
            if (b != this.ar) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "bp", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "be", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (b != this.ax) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "text", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (b != this.a3) {
                this.g("Text", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "am", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (b != this.ae) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "aq", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.g("Value", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XLabel.prototype, "disabled", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (b != this.ac) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XLabel.prototype.ch = function () {
        this.view.ae();
    };
    XLabel.prototype.onDetachedFromUI = function () {
        this.view.x();
    };
    XLabel.prototype.onAttachedToUI = function () {
        this.view.v();
    };
    XLabel.prototype.ao = function () {
        return this.view.f();
    };
    XLabel.prototype.au = function () {
        return this.q();
    };
    XLabel.prototype.bk = function () {
        var a = this.q();
        return a.q();
    };
    XLabel.prototype.q = function () {
        var a = new LabelVisualModelExport();
        var b = this.view.n;
        a.b = this.l;
        a.d = this.p;
        a.c = this.o;
        a.a = AppearanceHelper.a(NativeUI.ah(b));
        a.e = this.s;
        a.i = this.an;
        a.g = this.al;
        a.m = this.bi;
        a.n = this.bl;
        a.o = this.bn;
        a.l = this.ba;
        a.r = this.text;
        a.h = this.am;
        a.j = this.aq;
        a.f = this.disabled;
        a.p = this.e;
        if (this.w != null) {
            var c = this.w;
            if (this.view != null && c.n == null) {
                var d = this.view.k;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                a.s = c.n;
            }
            if (!isNaN_(c.d)) {
                a.k = c.d;
            }
            if (c.s != null) {
                a.w = c.s;
            }
            if (c.q != null) {
                a.u = c.q;
            }
            if (c.o != null) {
                a.t = c.q;
            }
        }
        return a;
    };
    XLabel.prototype.provideContainer = function (a) {
        this.view.w(a);
    };
    XLabel.$t = markType(XLabel, 'XLabel', XInputGroupItem.$);
    XLabel.da = BrushUtil.g(221, 0, 0, 0);
    XLabel.c7 = BrushUtil.g(255, 0, 153, 155);
    XLabel.c9 = BrushUtil.g(221, 0, 0, 0);
    XLabel.c8 = BrushUtil.g(255, 0, 153, 155);
    XLabel.c3 = BrushUtil.g(255, 24, 29, 31);
    XLabel.c0 = BrushUtil.g(255, 33, 150, 243);
    XLabel.c2 = BrushUtil.g(255, 24, 29, 31);
    XLabel.c1 = BrushUtil.g(255, 33, 150, 243);
    XLabel.k = 2;
    XLabel.db = ThemeResolver.e(XLabel.k, XLabel.da, XLabel.c3);
    XLabel.c4 = ThemeResolver.e(XLabel.k, XLabel.c7, XLabel.c0);
    XLabel.c6 = ThemeResolver.e(XLabel.k, XLabel.c9, XLabel.c2);
    XLabel.c5 = ThemeResolver.e(XLabel.k, XLabel.c8, XLabel.c1);
    XLabel.x = null;
    XLabel.at = 0;
    return XLabel;
}(XInputGroupItem));
export { XLabel };
/**
 * @hidden
 */
var XInput = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XInput, _super);
    function XInput() {
        var _this = _super.call(this) || this;
        _this.x = null;
        _this.a3 = 0;
        _this.a4 = 0;
        _this.t = 0;
        _this.bl = "";
        _this.bf = "";
        _this.ae = false;
        _this.bg = null;
        _this.af = false;
        _this.an = false;
        _this._view = null;
        _this.q = 0;
        _this.k = 1;
        _this.j = 1;
        _this.bk = null;
        _this.bn = "_";
        _this.ah = false;
        _this.dq = XInput.dw;
        _this.dp = XInput.dv;
        _this.y = null;
        _this.ds = XInput.dw;
        _this.keyDown = null;
        _this.keyUp = null;
        _this.keyPress = null;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.mouseDown = null;
        _this.mouseUp = null;
        _this.z = null;
        _this.bj = "text";
        _this.bm = "text";
        _this.dr = null;
        _this.bi = "ig-input-" + XInput.bb++;
        _this.a5 = 0;
        _this.ag = false;
        _this.bh = null;
        _this.be = null;
        _this.ak = false;
        _this.bd = null;
        _this.bo = null;
        _this.aj = false;
        _this.ai = false;
        _this.al = false;
        _this.change = null;
        _this.changing = null;
        _this.compositionStart = null;
        _this.compositionEnd = null;
        _this.am = true;
        _this.ad = null;
        _this.aw = false;
        _this.x = new MaskParsingService();
        var a = new InputView();
        a.b = _this;
        _this.view = a;
        _this.view.ao();
        XInput.ab = new FontInfo();
        XInput.ab.n = "'Segoe UI', Verdana";
        return _this;
    }
    Object.defineProperty(XInput.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (a) {
            this._view = a;
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.destroy = function () {
        this.provideContainer(null);
    };
    Object.defineProperty(XInput.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.g("ShiftType", enumGetBox(InputShiftType_$type, b), enumGetBox(InputShiftType_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "m", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            var b = this.k;
            this.k = a;
            if (b != this.k) {
                this.g("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "l", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (b != this.j) {
                this.g("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "b9", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.g("Mask", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "cd", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.g("PromptChar", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "aq", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.g("IncludeLiterals", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.h = function (a, b, c) {
        _super.prototype.h.call(this, a, b, c);
        switch (a) {
            case "TextColor":
            case "HoverTextColor":
            case "TextStyle":
                this.dm();
                break;
            case "ActualTextColor":
            case "ActualHoverTextColor":
            case "ActualTextStyle":
                this.dl();
                break;
            case "Value":
                if (!this.ai) {
                    this.view.at(this.cj);
                    if (this.b != null) {
                        this.b.mt();
                    }
                    if (this.b9 != null && !this.an) {
                        this.dn(this.cj);
                    }
                }
                break;
            case "Density":
                this.l = this.m == 0 ? 1 : this.m;
                break;
            case "ActualDensity":
                this.view.a0();
                this.view.az();
                break;
            case "InputGroup":
                this.c0();
                break;
            case "ShiftType":
                this.db();
                break;
            case "InputType":
                this.dc();
                break;
            case "Placeholder":
                this.da();
                break;
            case "Mask":
                this.cb = this.b9;
                break;
            case "PromptChar": break;
            case "IncludeLiterals": break;
            case "IsShown":
                this.c1();
                break;
            case "IsDisabled":
                this.view.au(this.aj);
                break;
            case "IsReadOnly":
                this.view.av(this.al);
                break;
        }
    };
    XInput.prototype.da = function () {
        this.view.aq();
    };
    XInput.prototype.dc = function () {
        this.view.as();
    };
    XInput.prototype.db = function () {
        this.view.az();
    };
    XInput.prototype.c0 = function () {
        this.view.az();
    };
    XInput.prototype.dm = function () {
        this.du = this.dy != null ? this.dy : XInput.dw;
        this.dt = this.dx != null ? this.dx : XInput.dw;
        this.aa = this.ac != null ? this.ac : XInput.ab;
    };
    XInput.prototype.dl = function () {
        if (this.aa != null) {
            this.view.a2(this.aa);
        }
        NativeUI.o(this.view.o, this.du);
    };
    Object.defineProperty(XInput.prototype, "du", {
        get: function () {
            return this.dq;
        },
        set: function (a) {
            var b = this.dq;
            this.dq = a;
            if (b != this.dq) {
                this.g("ActualTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "dt", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            var b = this.dp;
            this.dp = a;
            if (b != this.dp) {
                this.g("ActualHoverTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "aa", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.g("ActualTextStyle", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "dy", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            var b = this.ds;
            this.ds = a;
            if (b != this.ds) {
                this.g("TextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.cr = function () {
        if (this.b9 != null) {
            this.dj(this.cj);
        }
        if (null != this.lostFocus) {
            this.lostFocus(this, EventArgs.empty);
        }
    };
    XInput.prototype.cz = function () {
        if (this.b9 != null) {
            this.dk(this.cj);
        }
        if (null != this.gotFocus) {
            this.gotFocus(this, EventArgs.empty);
        }
    };
    XInput.prototype.c2 = function (a) {
        if (this.b9 != null) {
            var b = a.keyCode;
            if ((b == 17 && b == 90) || (b == 17 && b == 89)) {
                a.preventDefault();
            }
            this.t = b;
            this.a4 = this.a7();
            this.a3 = this.a6();
        }
        if (null != this.keyDown) {
            this.keyDown(this, a);
        }
    };
    XInput.prototype.c4 = function (a) {
        if (null != this.keyUp) {
            this.keyUp(this, a);
        }
    };
    XInput.prototype.c3 = function (a) {
        if (null != this.keyPress) {
            this.keyPress(this, a);
        }
    };
    XInput.prototype.c5 = function (a) {
        if (null != this.mouseDown) {
            this.mouseDown(this, a);
        }
    };
    XInput.prototype.c8 = function (a) {
        if (null != this.mouseUp) {
            this.mouseUp(this, a);
        }
    };
    XInput.prototype.c9 = function () {
        if (this.b9 != null) {
            this.bl = this.cj;
            this.a4 = this.a7();
        }
    };
    XInput.prototype.cx = function () {
        if (this.b9 != null) {
            if (!this.ae) {
                this.dk(this.bf);
            }
        }
    };
    XInput.prototype.cy = function () {
        if (this.b9 != null) {
            if (!this.ae) {
                this.dj(this.cj);
            }
        }
    };
    XInput.prototype.cs = function () {
        var _this = this;
        this.ai = true;
        this.cj = this.view.q();
        if (this.change != null) {
            this.change(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cj;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
        this.ai = false;
    };
    XInput.prototype.ct = function () {
        var _this = this;
        this.ai = true;
        this.cj = this.view.q();
        this.ai = false;
        if (this.b9 != null) {
            this.an = true;
            if (this.af) {
                this.a4 = this.a7();
            }
            if (this.cj.length < this.bl.length && this.t == 229) {
                this.t = 8;
            }
            var a = this.a7();
            var b = this.a6();
            var c = "";
            switch (this.t) {
                case 46:
                    this.a3 = this.a4 == this.a3 ? ++this.a3 : this.a3;
                    break;
                case 8:
                    this.a4 = this.a7();
                    break;
                default:
                    c = this.cj.substr(this.a4, this.a6() - this.a4);
                    break;
            }
            var d = new MaskOptions();
            d.a = this.b9;
            d.b = this.cd;
            var e = this.x.a(this.bl, c, d, this.a4, this.a3);
            this.cj = e.b;
            if (this.t == 8) {
                e.a = this.a4;
            }
            this.di(e.a, e.a);
            var f = this.x.i(this.cj, d);
            this.bf = this.aq ? this.cj : f;
            this.cl();
            this.an = false;
        }
        this.ai = true;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cj;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
        this.ai = false;
    };
    XInput.prototype.cv = function () {
        if (this.compositionStart != null) {
            this.compositionStart(this, new EventArgs());
        }
    };
    XInput.prototype.cu = function () {
        if (this.compositionEnd != null) {
            this.compositionEnd(this, new EventArgs());
        }
    };
    XInput.prototype.c6 = function () {
        this.as = true;
    };
    XInput.prototype.c7 = function () {
        this.as = false;
    };
    Object.defineProperty(XInput.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.g("TextStyle", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "b3", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.g("InputType", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "cb", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.g("Placeholder", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "dx", {
        get: function () {
            return this.dr;
        },
        set: function (a) {
            var b = this.dr;
            this.dr = a;
            if (b != this.dr) {
                this.g("HoverTextColor", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "b0", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.g("Id", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "ao", {
        get: function () {
            return this.ag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "ba", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            this.ag = true;
            if (b != this.a5) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "bx", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.g("TabIndex", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "bt", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.g("AriaLabel", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "as", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (b != this.ak) {
                this.g("IsHover", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "cj", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.g("Value", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "ap", {
        get: function () {
            return !stringIsNullOrEmpty(this.cj);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "disabled", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (b != this.aj) {
                this.g("IsDisabled", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "readonly", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.g("IsReadOnly", b, this.al);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.dd = function () {
    };
    XInput.prototype.onDetachedFromUI = function () {
        this.view.am();
    };
    XInput.prototype.onAttachedToUI = function () {
        this.view.aj();
    };
    XInput.prototype.av = function () {
        return this.view.f();
    };
    XInput.prototype.bc = function () {
        return this.n();
    };
    XInput.prototype.bw = function () {
        var a = this.n();
        return a.n();
    };
    XInput.prototype.n = function () {
        var a = new InputVisualModelExport();
        var b = this.view.o;
        a.h = this.view.j.rootWrapper.getNativeElement().offsetTop;
        a.f = this.view.j.rootWrapper.getNativeElement().offsetLeft;
        a.c = this.r;
        a.b = this.l;
        a.j = this.b9;
        a.m = this.cd;
        a.d = this.aq;
        a.a = AppearanceHelper.a(NativeUI.ah(b));
        a.i = this.b3;
        a.l = this.cb;
        a.e = this.as;
        a.t = this.cj;
        a.k = this.e;
        if (this.aa != null) {
            var c = this.aa;
            if (this.view != null && c.n == null) {
                var d = this.view.j;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                a.o = c.n;
            }
            if (!isNaN_(c.d)) {
                a.g = c.d;
            }
            if (c.s != null) {
                a.s = c.s;
            }
            if (c.q != null) {
                a.q = c.q;
            }
            if (c.o != null) {
                a.p = c.q;
            }
        }
        return a;
    };
    XInput.prototype.di = function (a, b) {
        this.view.ax(a, b);
    };
    XInput.prototype.provideContainer = function (a) {
        this.view.al(a);
    };
    XInput.prototype.cm = function () {
        this.cr();
        this.view.ak();
    };
    XInput.prototype.focus = function (a) {
        if (a === void 0) {
            a = false;
        }
        this.cz();
        this.view.an(a);
    };
    XInput.prototype.dg = function () {
        this.view.ar();
    };
    XInput.prototype.dk = function (a) {
        this.an = true;
        var b = new MaskOptions();
        b.a = this.b9;
        b.b = this.cd;
        this.cj = this.x.h(this.cj, b);
        this.bl = this.cj;
        this.an = false;
    };
    XInput.prototype.dj = function (a) {
        this.an = true;
        var b = new MaskOptions();
        b.a = this.b9;
        b.b = this.cd;
        if (a == this.x.h(null, b)) {
            this.cj = "";
        }
        this.an = false;
    };
    XInput.prototype.dn = function (a) {
        var _this = this;
        var b = new MaskOptions();
        b.a = this.b9;
        b.b = this.cd;
        if (this.cd != null && this.cd.length > 1) {
            b.b = this.cd.substr(0, 1);
        }
        this.cj = a != null ? this.x.h(a, b) : "";
        this.bf = this.aq ? this.cj : a;
        if (this.changing != null) {
            this.changing(this, ((function () {
                var $ret = new InputChangeEventArgs();
                $ret.value = _this.cj;
                $ret.isCompositionInProgress = _this.view.e;
                return $ret;
            })()));
        }
    };
    XInput.prototype.cl = function () {
        this.bl = this.cj;
        this.af = false;
        this.a4 = 0;
        this.a3 = 0;
        this.t = 0;
    };
    XInput.prototype.a7 = function () {
        var a = this.view.n();
        var b = this.view.m();
        return a == b && this.af ? b - this.bg.length : a;
    };
    XInput.prototype.a6 = function () {
        return this.view.m();
    };
    Object.defineProperty(XInput.prototype, "selectionStart", {
        get: function () {
            return this.a7();
        },
        set: function (a) {
            this.view.ay(a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "selectionEnd", {
        get: function () {
            return this.a6();
        },
        set: function (a) {
            this.view.aw(a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XInput.prototype, "au", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (b != this.am) {
                this.g("IsShown", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.dh = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = this.aw;
        if (!b) {
            this.aw = true;
        }
        try {
            this.au = a;
        }
        finally {
            if (!b) {
                this.aw = c;
            }
        }
    };
    XInput.prototype.c1 = function () {
        this.co();
        this.de(this.ad, this.au);
    };
    XInput.prototype.co = function () {
        this.view.ai();
        if (this.ad == null) {
            this.ad = KeyFrameAnimationFactory.f.c(this.view.a(this.i).m(new AnimationKeyFrameProperty(1, 0)).m(new AnimationKeyFrameProperty(1, 1)));
        }
    };
    Object.defineProperty(XInput.prototype, "i", {
        get: function () {
            var a = new AnimationKeyFrameEffectTiming();
            a.g = 300;
            a.b = 0;
            return a;
        },
        enumerable: false,
        configurable: true
    });
    XInput.prototype.de = function (a, b) {
        var c = a.playbackRate < 0;
        if (b != c) {
            a.play();
        }
        else {
            a.reverse();
        }
        if (this.aw) {
            a.finish();
            a.commitStyles();
            return;
        }
        a.finished.f(function (d) { return a.commitStyles(); });
    };
    XInput.$t = markType(XInput, 'XInput', XInputGroupItem.$);
    XInput.dw = BrushUtil.g(221, 0, 0, 0);
    XInput.dv = BrushUtil.g(221, 0, 0, 0);
    XInput.ab = null;
    XInput.bb = 0;
    return XInput;
}(XInputGroupItem));
export { XInput };
//# sourceMappingURL=InputGroupView_combined.js.map
